<template>
  <div class="g-map-wrapper">
    <!-- 地图区域 -->
    <div id="g-container" :style="{ width: '100%', height: '100%' }" />
    <!-- 绘制面板 -->
    <div
      v-if="!mapOnly"
      class="g-action-panel"
      :class="{ 'g-action-panel--layer': isLayerRoute }"
      :style="{ right: drawVisible ? '356px' : '16px' }"
    >
      <div :class="state.currentType === 'pin' ? 'g-action-item selection' : 'g-action-item'" @click="draw('pin', true)">
        <a><a-image :src="pin" :preview="false" /></a>
      </div>
      <div :class="state.currentType === 'polyline' ? 'g-action-item selection' : 'g-action-item'" @click="draw('polyline', true)">
        <a><LineOutlined :rotate="135" class="fz20"/></a>
      </div>
      <div :class="state.currentType === 'polygon' && !state.isFlightArea ? 'g-action-item selection' : 'g-action-item'" @click="draw('polygon', true)">
        <a><BorderOutlined class="fz18" /></a>
      </div>
      <FlightAreaActionIcon class="g-action-item mt10" :class="{'selection': mouseMode && state.isFlightArea}" @select-action="selectFlightAreaAction" @click="selectFlightAreaAction"/>
      <div v-if="mouseMode" class="g-action-item" @click="draw('off', false)">
        <a style="color: red;"><CloseOutlined /></a>
      </div>
    </div>
    <a-tooltip v-if="mapLocateControlVisible" title="定位当前设备" placement="left">
      <button type="button" title="定位当前设备" class="tsa-map-locate-control" @pointerdown.stop @click.stop.prevent="locateCurrentTsaTarget">
        <AimOutlined />
      </button>
    </a-tooltip>
    <a-tooltip v-if="mapSettingsControlVisible" :title="mapSettingsVisible ? '收起地图设置' : '地图设置'" placement="left">
      <button
        type="button"
        title="地图设置"
        class="map-settings-control"
        :class="{
          'map-settings-control--active': mapSettingsVisible,
          'map-settings-control--compact': isLayerRoute || isWaylineRoute || isMappingRoute || isFlightRecordDetailRoute
        }"
        @pointerdown.stop
        @click.stop.prevent="toggleMapSettings"
      >
        <SettingOutlined />
      </button>
    </a-tooltip>
    <!-- 飞机OSD -->
    <div v-if="!mapOnly && osdVisible.visible && !osdVisible.is_dock" v-drag-window class="osd-panel fz12">
      <div class="drag-title osd-panel__title">
        <span class="osd-panel__heading">{{ osdVisible.callsign }}</span>
        <button type="button" class="osd-panel__close drag-ignore" @pointerdown.stop @click.stop.prevent="closeOsdPanel"><CloseOutlined /></button>
      </div>
      <div class="osd-panel__serials">
        <div class="osd-panel__serial-item">
          <span class="osd-panel__serial-label">网关 SN</span>
          <span class="osd-panel__serial-value">{{ osdVisible.gateway_sn || str }}</span>
        </div>
        <div class="osd-panel__serial-item">
          <span class="osd-panel__serial-label">无人机 SN</span>
          <span class="osd-panel__serial-value">{{ currentDroneSn || str }}</span>
        </div>
      </div>
      <div style="height: 82%;">
        <div class="flex-column flex-align-center flex-justify-center" style="margin-top: -5px; padding-top: 25px; float: left; width: 60px; background: #2d2d2d;">
          <a-tooltip :title="aircraftModelText">
            <div style="width: 90%;" class="flex-column flex-align-center flex-justify-center">
              <span><a-image :src="M30" :preview="false"/></span>
              <span>{{ aircraftModelText }}</span>
            </div>
          </a-tooltip>
        </div>
        <div class="osd">
            <a-row>
              <a-col span="16" :style="deviceInfo.device.mode_code === EModeCode.Disconnected ? 'color: red; font-weight: 700;': 'color: rgb(25,190,107)'">{{ EModeCode[deviceInfo.device.mode_code] }}</a-col>
            </a-row>
            <a-row>
              <a-col span="6">
                <a-tooltip title="Signal strength">
                  <span>HD</span>
                  <span class="ml10">{{ deviceInfo.gateway?.transmission_signal_quality }}</span>
                </a-tooltip>
              </a-col>
              <a-col span="6">
                <a-tooltip title="RC Battery Level">
                  <span><ThunderboltOutlined class="fz14"/></span>
                  <span class="ml10">{{ deviceInfo.gateway && deviceInfo.gateway.capacity_percent !== str ? deviceInfo.gateway?.capacity_percent + ' %' : deviceInfo.gateway?.capacity_percent }}</span>
                </a-tooltip>
              </a-col>

              <a-col span="6">
                <a-tooltip title="Drone Battery Level">
                  <span><ThunderboltOutlined class="fz14"/></span>
                  <span class="ml10">{{ deviceInfo.device.battery.capacity_percent !== str ? deviceInfo.device.battery.capacity_percent + ' %' : deviceInfo.device.battery.capacity_percent }}</span>
                </a-tooltip>
              </a-col>
            </a-row>
            <a-row>
              <a-tooltip title="RTK Fixed">
                <a-col span="6" class="flex-row flex-align-center flex-justify-start">
                  <span>Fixed</span>
                  <span class="ml10 circle" :style="deviceInfo.device.position_state.is_fixed === 1 ? 'backgroud: rgb(25,190,107);' : ' background: red;'"></span>
                </a-col>
              </a-tooltip>
              <a-col span="6">
                <a-tooltip title="GPS">
                  <span>GPS</span>
                  <span class="ml10">{{ deviceInfo.device.position_state.gps_number }}</span>
                </a-tooltip>
              </a-col>
              <a-col span="6">
                <a-tooltip title="RTK">
                  <span><TrademarkOutlined class="fz14"/></span>
                  <span class="ml10">{{ deviceInfo.device.position_state.rtk_number }}</span>
                </a-tooltip>
              </a-col>
            </a-row>
            <a-row>
              <a-col span="6">
                <a-tooltip title="Flight Mode">
                  <span><ControlOutlined class="fz16" /></span>
                  <span class="ml10">{{ EGear[deviceInfo.device.gear] }}</span>
                </a-tooltip>
              </a-col>
              <a-col span="6">
                <a-tooltip title="Altitude above sea level">
                  <span>ASL</span>
                  <span class="ml10">{{ deviceInfo.device.height === str ? str : deviceInfo.device.height.toFixed(2) + ' m'}}</span>
                </a-tooltip>
              </a-col>
              <a-col span="6">
                <a-tooltip title="Altitude above takeoff level">
                  <span>ALT</span>
                  <span class="ml10">{{ deviceInfo.device.elevation === str ? str : deviceInfo.device.elevation.toFixed(2) + ' m' }}</span>
                </a-tooltip>
              </a-col>
              <a-col span="6">
                <a-tooltip title="Distance to Home Point">
                  <span>H</span>
                  <span class="ml10">{{ deviceInfo.device.home_distance === str ? str : deviceInfo.device.home_distance.toFixed(2) + ' m' }}</span>
                </a-tooltip>
              </a-col>
            </a-row>
            <a-row>
              <a-col span="6">
                <a-tooltip title="Horizontal Speed">
                  <span>H.S</span>
                  <span class="ml10">{{ deviceInfo.device.horizontal_speed === str ? str : deviceInfo.device.horizontal_speed.toFixed(2) + ' m/s'}}</span>
                </a-tooltip>
              </a-col>
              <a-col span="6">
                <a-tooltip title="Vertical Speed">
                  <span>V.S</span>
                  <span class="ml10">{{ deviceInfo.device.vertical_speed === str ? str : deviceInfo.device.vertical_speed.toFixed(2) + ' m/s'}}</span>
                </a-tooltip>
              </a-col>
              <a-col span="6">
                <a-tooltip title="Wind Speed">
                  <span>W.S</span>
                  <span class="ml10">{{ deviceInfo.device.wind_speed === str ? str : (deviceInfo.device.wind_speed / 10).toFixed(2) + ' m/s'}}</span>
                </a-tooltip>
              </a-col>
            </a-row>
        </div>
      </div>
      <div class="battery-slide" v-if="deviceInfo.device.battery.remain_flight_time !== 0">
        <div style="background: #535759;" class="width-100"></div>
        <div class="capacity-percent" :style="{ width: deviceInfo.device.battery.capacity_percent + '%'}"></div>
        <div class="return-home" :style="{ width: deviceInfo.device.battery.return_home_power + '%'}"></div>
        <div class="landing" :style="{ width: deviceInfo.device.battery.landing_power + '%'}"></div>
        <div class="white-point" :style="{ left: deviceInfo.device.battery.landing_power + '%'}"></div>
        <div class="battery" :style="{ left: deviceInfo.device.battery.capacity_percent + '%' }">
          {{ Math.floor(deviceInfo.device.battery.remain_flight_time / 60) }}:
          {{ 10 > (deviceInfo.device.battery.remain_flight_time % 60) ? '0' : ''}}{{deviceInfo.device.battery.remain_flight_time % 60 }}
        </div>
      </div>
    </div>
    <!-- 机场OSD -->
    <div v-if="!mapOnly && osdVisible.visible && osdVisible.is_dock" v-drag-window class="osd-panel osd-panel--dock fz12">
      <div class="drag-title dock-panel__title">
        <span
          class="dock-panel__task"
          :class="{
            'dock-panel__task--debugging': isDockRemoteDebugging,
            'dock-panel__task--control': !isDockRemoteDebugging && (flightControlActive || dockRemoteControlActive)
          }"
        >{{ dockTaskText }}</span>
        <span class="dock-panel__split">{{ str }}</span>
        <span class="dock-panel__heading">{{ osdVisible.gateway_callsign || str }}</span>
        <button type="button" class="osd-panel__close drag-ignore" @pointerdown.stop @click.stop.prevent="closeOsdPanel"><CloseOutlined /></button>
      </div>

      <div class="dock-panel__content">
        <div class="dock-panel__rail" :class="{ 'dock-panel__rail--remote-debug': isDockRemoteDebugging }">
          <a-tooltip placement="right">
            <template #title>
              <div>设备型号: {{ dockModelText }}</div>
              <div>设备SN: {{ osdVisible.gateway_sn || str }}</div>
              <div>设备项目呼号: {{ osdVisible.gateway_callsign || str }}</div>
            </template>
            <button type="button" class="dock-panel__device dock-panel__device--active">
              <span class="dock-panel__device-icon"><a-image :src="dockIcon" :preview="false"/></span>
              <span class="dock-panel__device-name">{{ dockModelText }}</span>
            </button>
          </a-tooltip>

          <a-tooltip placement="right">
            <template #title>
              <div>设备型号: {{ aircraftModelText }}</div>
              <div>设备SN: {{ currentDroneSn || str }}</div>
              <div>设备项目呼号: {{ osdVisible.callsign || str }}</div>
            </template>
            <button type="button" class="dock-panel__device" :class="{ 'dock-panel__device--muted': !isAircraftOnline }">
              <span class="dock-panel__device-icon dock-panel__device-icon--aircraft"><a-image :src="M30" :preview="false"/></span>
              <span class="dock-panel__device-name">{{ aircraftModelText }}</span>
            </button>
          </a-tooltip>
        </div>

        <div class="dock-panel__main">
          <section class="dock-panel__section dock-panel__section--dock">
            <div class="dock-panel__status-row">
              <span class="dock-panel__status" :class="{ 'dock-panel__status--offline': isDockOffline }">{{ dockModeText }}</span>
              <span class="dock-panel__pill">{{ dockHealthText }}</span>
            </div>
            <p v-if="dockOfflineHint" class="dock-panel__offline-hint" role="status">{{ dockOfflineHint }}</p>
            <div class="dock-panel__telemetry">
              <a-popover placement="bottomLeft" :trigger="['hover', 'focus']" overlay-class-name="tsa-flight-weather-popover">
                <template #content>
                  <div class="flight-weather-card" @pointerdown.stop>
                    <div
                      class="flight-weather-card__recommendation"
                      :class="{ 'flight-weather-card__recommendation--danger': !flightWeatherEvaluation.recommended }"
                    >
                      <strong>{{ dockFlightText }}</strong>
                      <span v-if="flightWeatherEvaluation.recommended">当前与未来两小时未命中天气限制</span>
                      <div v-else class="flight-weather-card__reasons">
                        <span v-for="reason in flightWeatherEvaluation.reasons" :key="reason">{{ reason }}</span>
                      </div>
                    </div>

                    <section class="flight-weather-card__section">
                      <h4>机场天气数据（实时测量）</h4>
                      <div class="flight-weather-card__grid flight-weather-card__grid--four">
                        <div class="flight-weather-card__item"><strong>{{ dockMeasuredWindText }}</strong><span>风速计</span></div>
                        <div class="flight-weather-card__item"><strong>{{ dockRainfallText }}</strong><span>雨量计</span></div>
                        <div class="flight-weather-card__item"><strong>{{ dockMeasuredTemperatureText }}</strong><span>环境温度</span></div>
                        <div class="flight-weather-card__item"><strong>{{ dockMeasuredHumidityText }}</strong><span>相对湿度</span></div>
                      </div>
                    </section>

                    <template v-if="weatherState.data">
                      <section class="flight-weather-card__section">
                        <h4>和风天气实况</h4>
                        <div class="flight-weather-card__grid">
                          <div class="flight-weather-card__item"><strong>{{ weatherState.data.now.text }}</strong><span>天气状态</span></div>
                          <div class="flight-weather-card__item"><strong>{{ formatWeatherMeasurement(weatherState.data.now.wind_speed_mps, 'm/s', 1) }}</strong><span>风速</span></div>
                          <div class="flight-weather-card__item"><strong>{{ formatPrecipitation(weatherState.data.now.precipitation_mm) }}</strong><span>降水量</span></div>
                          <div class="flight-weather-card__item"><strong>{{ formatWeatherMeasurement(weatherState.data.now.temperature_c, '°C', 1) }}</strong><span>温度</span></div>
                          <div class="flight-weather-card__item"><strong>{{ formatWeatherMeasurement(weatherState.data.now.humidity_percent, '%') }}</strong><span>相对湿度</span></div>
                          <div class="flight-weather-card__item"><strong>{{ formatWeatherMeasurement(weatherState.data.now.pressure_hpa, 'hPa') }}</strong><span>气压</span></div>
                        </div>
                      </section>

                      <section class="flight-weather-card__section">
                        <h4>未来两小时天气预报</h4>
                        <div
                          v-for="(hour, index) in weatherState.data.hourly"
                          :key="hour.forecast_at"
                          class="flight-weather-card__forecast"
                        >
                          <div class="flight-weather-card__forecast-time">未来 {{ index + 1 }} 小时 · {{ formatWeatherTime(hour.forecast_at) }}</div>
                          <div class="flight-weather-card__grid">
                            <div class="flight-weather-card__item"><strong>{{ hour.text }}</strong><span>天气状态</span></div>
                            <div class="flight-weather-card__item"><strong>{{ formatWeatherMeasurement(hour.wind_speed_mps, 'm/s', 1) }}</strong><span>预报风速</span></div>
                            <div class="flight-weather-card__item"><strong>{{ formatPrecipitation(hour.precipitation_mm) }}</strong><span>降水量</span></div>
                            <div class="flight-weather-card__item"><strong>{{ formatWeatherMeasurement(hour.temperature_c, '°C', 1) }}</strong><span>温度</span></div>
                            <div class="flight-weather-card__item"><strong>{{ formatWeatherMeasurement(hour.humidity_percent, '%') }}</strong><span>相对湿度</span></div>
                            <div class="flight-weather-card__item"><strong>{{ formatWeatherMeasurement(hour.precipitation_probability, '%') }}</strong><span>降水概率</span></div>
                          </div>
                        </div>
                      </section>
                    </template>
                    <div v-else class="flight-weather-card__empty">
                      <LoadingOutlined v-if="weatherState.loading" class="flight-weather-card__loading" />
                      <span>{{ weatherState.loading ? '正在获取和风天气数据…' : (weatherState.error || '暂无和风天气数据') }}</span>
                    </div>

                    <div class="flight-weather-card__footer">
                      <span v-if="weatherState.data">更新时间 {{ formatWeatherTime(weatherState.data.updated_at) }}</span>
                      <a href="https://www.qweather.com" target="_blank" rel="noopener noreferrer" @click.stop>天气服务由和风天气驱动</a>
                    </div>
                  </div>
                </template>
                <span
                  class="dock-panel__metric drag-ignore"
                  :class="{ 'dock-panel__metric--danger': !flightWeatherEvaluation.recommended }"
                  tabindex="0"
                  @pointerdown.stop
                >
                  <RocketOutlined />{{ dockFlightText }}
                </span>
              </a-popover>
              <a-tooltip title="环境温度">
                <span class="dock-panel__metric"><span class="dock-panel__metric-mark">℃</span>{{ dockTemperatureText }}</span>
              </a-tooltip>
              <a-tooltip title="舱内温度">
                <span class="dock-panel__metric"><span class="dock-panel__metric-mark">舱</span>{{ dockCabinTemperatureText }}</span>
              </a-tooltip>
              <a-tooltip title="网络状态">
                <span class="dock-panel__metric" :style="qualityStyle">
                  <SignalFilled />
                  {{ dockNetworkText }}
                </span>
              </a-tooltip>
              <a-tooltip title="机场任务次数">
                <span class="dock-panel__metric"><FolderOpenOutlined />{{ dockJobText }}</span>
              </a-tooltip>
            </div>
            <div class="dock-panel__actions">
              <button type="button" class="dock-panel__action dock-panel__action--wide" :class="{ 'dock-panel__action--active': dockLiveVisible }" :disabled="!osdVisible.gateway_sn || (isDockOffline && !dockLiveVisible)" :title="isDockOffline && !dockLiveVisible ? '机场离线，无法开启直播' : undefined" @click="toggleDockLive">
                {{ dockLiveVisible ? '关闭机场直播' : '机场直播' }}
              </button>
              <button type="button" class="dock-panel__icon-action drag-ignore" :class="{ 'dock-panel__icon-action--active': dockControlPanelVisible }" :disabled="isDockOffline" :title="isDockOffline ? '机场离线，控制面板不可用' : '机场控制面板'" @click="toggleDockControlPanel">
                <ControlOutlined />
              </button>
            </div>
            <DockControlPanel v-if="dockControlPanelVisible" :sn="osdVisible.gateway_sn" :deviceInfo="deviceInfo" @close-control-panel="onCloseControlPanel">
            </DockControlPanel>
          </section>

          <section class="dock-panel__section dock-panel__section--aircraft">
            <div class="dock-panel__status-row">
              <span class="dock-panel__status" :class="{ 'dock-panel__status--offline': !isAircraftOnline }">{{ aircraftModeText }}</span>
              <span class="dock-panel__pill">{{ aircraftHealthText }}</span>
            </div>
            <div class="dock-panel__camera-row">
              <button type="button" class="dock-panel__action dock-panel__action--ghost" disabled>辅助影像</button>
              <button type="button" class="dock-panel__action" :class="{ 'dock-panel__action--active': droneLiveVisible }" :disabled="droneLiveButtonDisabled" :title="droneLiveButtonTitle" @click="toggleDroneLive">
                {{ droneLiveVisible ? '关闭无人机直播' : aircraftModelText }}
              </button>
              <button
                type="button"
                class="dock-panel__action dock-panel__control-action drag-ignore"
                :class="{ 'dock-panel__action--active': flightControlActive }"
                :disabled="!osdVisible.gateway_sn || flightControlLoading || (isDockOffline && !flightControlActive)"
                :title="isDockOffline && !flightControlActive ? '机场离线，无法获取控制权' : flightControlButtonTitle"
                @click="toggleFlightControl"
              >
                <span v-if="flightControlLoading" class="dock-panel__loading">
                  <LoadingOutlined class="dock-panel__loading-icon" />
                  <span>处理中</span>
                </span>
                <span v-else>{{ flightControlButtonText }}</span>
              </button>
            </div>
            <button
              type="button"
              class="dock-panel__action dock-panel__action--wide dock-panel__cockpit drag-ignore"
              :class="{ 'dock-panel__cockpit--enabled': cockpitButtonEnabled }"
              :disabled="!cockpitButtonEnabled"
              :title="cockpitButtonTitle"
              @pointerdown.stop
              @click.stop.prevent="openCockpit"
            >
              虚拟座舱
              <span v-if="flightControlActive">（{{ controlOwnerText }} 控制中）</span>
            </button>
          </section>
        </div>
      </div>

      <div v-if="dockLiveVisible || droneLiveVisible" class="dock-panel__live-stack">
        <AgoraLiveInlinePanel
          v-if="dockLiveVisible"
          :key="dockLiveWindowId"
          :targetSn="osdVisible.gateway_sn"
          :gatewaySn="osdVisible.gateway_sn"
          source-type="dock"
          title="机场直播"
          :active="dockLiveVisible"
          close-on-stop
          :ref="setLivePanelRef(dockLiveWindowId)"
          @live-state-change="onLiveStateChange(dockLiveWindowId, $event)"
          @request-close="closeLiveWindow(dockLiveWindowId)"
        />
        <AgoraLiveInlinePanel
          v-if="droneLiveVisible"
          :key="droneLiveWindowId"
          :targetSn="currentDroneSn"
          :gatewaySn="osdVisible.gateway_sn"
          source-type="drone"
          :drc-active="flightControlActive || dockRemoteControlActive"
          :title="`${aircraftModelText}直播`"
          :active="droneLiveVisible"
          close-on-stop
          :ref="setLivePanelRef(droneLiveWindowId)"
          @live-state-change="onLiveStateChange(droneLiveWindowId, $event)"
          @request-close="closeLiveWindow(droneLiveWindowId)"
        />
      </div>

      <div class="dock-panel__status-grid">
        <a-tooltip title="图传上行 / 下行">
          <div class="dock-panel__grid-item">
            <SignalFilled />
            <span>{{ sdrQualityText }}</span>
          </div>
        </a-tooltip>
        <a-tooltip title="RTK">
          <div class="dock-panel__grid-item dock-panel__grid-item--warn">
            <span>RTK</span>
            <span>{{ rtkText }}</span>
          </div>
        </a-tooltip>
        <a-tooltip title="无人机电量">
          <div class="dock-panel__grid-item">
            <BatteryWorking />
            <span>{{ aircraftBatteryText }}</span>
          </div>
        </a-tooltip>
        <a-tooltip title="风速">
          <div class="dock-panel__grid-item dock-panel__grid-item--muted">
            <span>↝</span>
            <span>{{ aircraftWindText }}</span>
          </div>
        </a-tooltip>
        <a-tooltip title="相对起飞点高度">
          <div class="dock-panel__grid-item">
            <span>ALT</span>
            <span>{{ aircraftAltitudeText }}</span>
          </div>
        </a-tooltip>
        <a-tooltip title="水平速度">
          <div class="dock-panel__grid-item">
            <span>H.S</span>
            <span>{{ aircraftHorizontalSpeedText }}</span>
          </div>
        </a-tooltip>
        <a-tooltip title="距返航点距离">
          <div class="dock-panel__grid-item dock-panel__grid-item--home">
            <span>H</span>
            <span>{{ aircraftHomeText }}</span>
          </div>
        </a-tooltip>
        <a-tooltip title="直播延迟">
          <div class="dock-panel__grid-item">
            <span>N</span>
            <span>{{ str }}</span>
          </div>
        </a-tooltip>
      </div>

      <div class="battery-slide dock-panel__battery" v-if="deviceInfo.device && deviceInfo.device.battery.remain_flight_time !== 0">
        <div style="background: #535759;" class="width-100"></div>
        <div class="capacity-percent" :style="{ width: deviceInfo.device.battery.capacity_percent + '%'}"></div>
        <div class="return-home" :style="{ width: deviceInfo.device.battery.return_home_power + '%'}"></div>
        <div class="landing" :style="{ width: deviceInfo.device.battery.landing_power + '%'}"></div>
        <div class="white-point" :style="{ left: deviceInfo.device.battery.landing_power + '%'}"></div>
        <div class="battery" :style="{ left: deviceInfo.device.battery.capacity_percent + '%' }">
          {{ Math.floor(deviceInfo.device.battery.remain_flight_time / 60) }}:
          {{ 10 > (deviceInfo.device.battery.remain_flight_time % 60) ? '0' : ''}}{{deviceInfo.device.battery.remain_flight_time % 60 }}
        </div>
      </div>
    </div>
    <!-- tsa live floating window -->
    <div
      v-for="(liveWindow, index) in floatingLiveWindows"
      :key="liveWindow.id"
      class="tsa-live-window"
      :style="getLiveWindowStyle(index)"
      v-drag-window="{ resizable: true, minWidth: 460, minHeight: 340 }"
    >
      <div class="drag-title tsa-live-window__title">
        <div class="tsa-live-window__heading">
          <span>{{ liveWindow.title }}</span>
          <span class="tsa-live-window__sn">{{ liveWindow.targetSn }}</span>
        </div>
        <button type="button" class="tsa-live-window__close drag-ignore" @pointerdown.stop @click.stop.prevent="closeLiveWindow(liveWindow.id)"><CloseOutlined /></button>
      </div>
      <div class="tsa-live-window__body">
        <AgoraLiveInlinePanel
          :key="liveWindow.id"
          :targetSn="liveWindow.targetSn"
          :gatewaySn="liveWindow.gatewaySn"
          :source-type="liveWindow.type"
          :title="liveWindow.title"
          :active="true"
          close-on-stop
          :ref="setLivePanelRef(liveWindow.id)"
          @live-state-change="onLiveStateChange(liveWindow.id, $event)"
          @request-close="closeLiveWindow(liveWindow.id)"
        />
      </div>
      <div class="drag-resize-handle tsa-live-window__resize"></div>
    </div>
    <!-- liveview -->
    <div class="liveview" v-if="!mapOnly && livestreamOthersVisible" v-drag-window  >
      <div style="height: 40px; width: 100%" class="drag-title"></div>
      <button type="button" class="liveview__close drag-ignore" @pointerdown.stop @click.stop.prevent="closeLivestreamOthers"><CloseOutlined /></button>
      <LivestreamOthers />
    </div>
    <div class="liveview" v-if="!mapOnly && livestreamAgoraVisible" v-drag-window  >
      <div style="height: 40px; width: 100%" class="drag-title"></div>
      <button type="button" class="liveview__close drag-ignore" @pointerdown.stop @click.stop.prevent="closeLivestreamAgora"><CloseOutlined /></button>
      <LivestreamAgora />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, nextTick, onBeforeUnmount, onMounted, reactive, ref, watch } from 'vue'
import { hasMap3DOwner } from '/@/utils/map-3d-owners'
import {
  generateLineContent,
  generatePointContent,
  generatePolyContent
} from '../utils/map-layer-utils'
import { postElementsReq } from '/@/api/layer'
import { MapDoodleType, MapElementEnum } from '/@/constants/map'
import { useGMapManage } from '/@/hooks/use-g-map'
import { useGMapCover } from '/@/hooks/use-g-map-cover'
import { useMouseTool } from '/@/hooks/use-mouse-tool'
import { getApp, getRoot } from '/@/root'
import { useMyStore } from '/@/store'
import { GeojsonCoordinate } from '/@/types/map'
import { MapDoodleEnum } from '/@/types/map-enum'
import { PostElementsBody } from '/@/types/mapLayer'
import {
  appendFlightTrackCoordinate,
  COCKPIT_FLIGHT_TRACK_MAX_POINTS,
  COCKPIT_FLIGHT_TRACK_OUTLINE_WEIGHT,
  COCKPIT_FLIGHT_TRACK_STROKE_DASHARRAY,
  COCKPIT_FLIGHT_TRACK_STROKE_STYLE,
  COCKPIT_FLIGHT_TRACK_STROKE_WEIGHT,
  selectCockpitMapCenter,
  transformMapElementCoordinates,
} from '/@/utils/map-coordinate'
import { uuidv4 } from '/@/utils/uuid'
import { wgs84togcj02 } from '/@/vendors/coordtransform'
import { deviceTsaUpdate } from '/@/hooks/use-g-map-tsa'
import {
  DeviceOsd, DeviceStatus, DockOsd, EGear, EModeCode, GatewayOsd, EDockModeCode,
  NetworkStateQualityEnum, NetworkStateTypeEnum, OSDVisible, DEVICE_NAME, DrcStateEnum, RainfallEnum
} from '/@/types/device'
import pin from '/@/assets/icons/pin-2d8cf0.svg'
import M30 from '/@/assets/icons/m30.png'
import dockIcon from '/@/assets/icons/dock.png'
import droneIcon from '/@/assets/icons/drone.png'
import BatteryWorking from '@icon-park/vue-next/es/icons/BatteryWorking'
import {
  BorderOutlined, LineOutlined, CloseOutlined, ControlOutlined, TrademarkOutlined,
  ThunderboltOutlined, SignalFilled, RocketOutlined, FolderOpenOutlined, AimOutlined, SettingOutlined, LoadingOutlined
} from '@ant-design/icons-vue'
import { EDeviceTypeName, ELocalStorageKey, ERouterName } from '../types'
import DockControlPanel from './g-map/DockControlPanel.vue'
import { useDockControl } from './g-map/use-dock-control'
import AgoraLiveInlinePanel from './g-map/AgoraLiveInlinePanel.vue'
import { useConnectMqtt } from './g-map/use-connect-mqtt'
import { useMqtt, DeviceTopicInfo } from './g-map/use-mqtt'
import { postDrcEnter, postDrcExit } from '/@/api/drc'
import { DRC_METHOD } from '/@/types/drc'
import EventBus from '/@/event-bus'
import { message } from 'ant-design-vue'
import LivestreamOthers from './livestream-others.vue'
import LivestreamAgora from './livestream-agora.vue'
import FlightAreaActionIcon from './flight-area/FlightAreaActionIcon.vue'
import { EFlightAreaType } from '../types/flight-area'
import { useFlightArea } from './flight-area/use-flight-area'
import { useFlightAreaDroneLocationEvent } from './flight-area/use-flight-area-drone-location-event'
import { clearTsaLiveWindowState, clearTsaOsdState, getTsaPageState, saveTsaCockpitState, saveTsaLiveWindowsState } from '/@/utils/tsa-page-state'
import { getFlightWeather } from '/@/api/weather'
import { FlightWeatherData } from '/@/types/flight-weather'
import { evaluateFlightWeather } from '/@/utils/flight-weather'
import { resolveSelectedOsdMirror } from '/@/utils/tsa-osd-mirror'
import { resolveAircraftBatteryPercent } from '/@/utils/device-osd'
import { ensureAliyunLiveExitAllowed } from '/@/components/aliyun-live/aliyun-live-exit-guard'
import {
  clearDrcControlSession,
  getDrcControlSession,
  setDrcControlSession,
  shouldInvalidateDrcSession,
} from '/@/utils/drc-lease'

type LiveWindowType = 'dock' | 'drone'
interface LiveWindow {
  id: string,
  type: LiveWindowType,
  targetSn: string,
  gatewaySn?: string,
  title: string,
  liveState: boolean,
}

interface AgoraLiveInlinePanelRef {
  stopLive?: () => Promise<void>
}

interface TsaLocateDockPayload {
  dockSn: string,
  dockName?: string,
}

const browserLocationMapRoutes = new Set([
  '/' + ERouterName.TSA,
  '/' + ERouterName.LAYER,
  '/' + ERouterName.WAYLINE,
  '/' + ERouterName.FLIGHT_AREA,
])

export default defineComponent({
  components: {
    BorderOutlined,
    LineOutlined,
    CloseOutlined,
    ControlOutlined,
    TrademarkOutlined,
    ThunderboltOutlined,
    BatteryWorking,
    SignalFilled,
    FolderOpenOutlined,
    DockControlPanel,
    AgoraLiveInlinePanel,
    RocketOutlined,
    AimOutlined,
    SettingOutlined,
    LoadingOutlined,
    LivestreamOthers,
    LivestreamAgora,
    FlightAreaActionIcon,
  },
  name: 'GMap',
  props: {
    suspended: {
      type: Boolean,
      default: false,
    },
    mapOnly: {
      type: Boolean,
      default: false,
    },
    mapControls: {
      type: Boolean,
      default: false,
    },
    targetLongitude: {
      type: Number,
      default: undefined,
    },
    targetLatitude: {
      type: Number,
      default: undefined,
    },
    airportLongitude: {
      type: Number,
      default: undefined,
    },
    airportLatitude: {
      type: Number,
      default: undefined,
    },
    airportName: {
      type: String,
      default: '机场',
    },
    aircraftLongitude: {
      type: Number,
      default: undefined,
    },
    aircraftLatitude: {
      type: Number,
      default: undefined,
    },
    aircraftHeading: {
      type: Number,
      default: undefined,
    },
    aircraftName: {
      type: String,
      default: '无人机',
    },
    flightTrackKey: {
      type: String,
      default: '',
    },
    flightTrackActive: {
      type: Boolean,
      default: false,
    },
    followAircraft: {
      type: Boolean,
      default: false,
    }
  },
  setup (props) {
    const useMouseToolHook = useMouseTool()
    const useGMapManageHook = useGMapManage()
    const deviceTsaUpdateHook = deviceTsaUpdate()
    const root = getRoot()

    const mouseMode = ref(false)
    const store = useMyStore()
    const state = reactive({
      currentType: '',
      coverIndex: 0,
      isFlightArea: false,
    })
    const str: string = '--'
    function createDefaultGatewayOsd () {
      return {
        capacity_percent: str,
        transmission_signal_quality: str,
      } as GatewayOsd
    }
    // An offline dock has no OSD; the panel still renders from this empty object.
    function emptyDockOsd () {
      return {} as DockOsd
    }
    function createDefaultDeviceOsd () {
      return {
        gear: -1,
        mode_code: EModeCode.Disconnected,
        height: str,
        home_distance: str,
        horizontal_speed: str,
        vertical_speed: str,
        wind_speed: str,
        wind_direction: str,
        elevation: str,
        position_state: {
          gps_number: str,
          is_fixed: 0,
          rtk_number: str
        },
        battery: {
          capacity_percent: str,
          landing_power: str,
          remain_flight_time: 0,
          return_home_power: str,
        },
        latitude: 0,
        longitude: 0,
      } as DeviceOsd
    }
    const osdMirrorDefaults = {
      dock: emptyDockOsd,
      device: createDefaultDeviceOsd,
      gateway: createDefaultGatewayOsd,
    }
    const deviceInfo = reactive({
      gateway: createDefaultGatewayOsd(),
      dock: emptyDockOsd(),
      device: createDefaultDeviceOsd(),
    })
    const shareId = computed(() => {
      return store.state.layerBaseInfo.share
    })
    const defaultId = computed(() => {
      return store.state.layerBaseInfo.default
    })
    const drawVisible = computed(() => {
      return store.state.drawVisible
    })
    const livestreamOthersVisible = computed(() => {
      return store.state.livestreamOthersVisible
    })
    const livestreamAgoraVisible = computed(() => {
      return store.state.livestreamAgoraVisible
    })
    const osdVisible = computed(() => {
      return store.state.osdVisible
    })
    const liveWindows = ref<LiveWindow[]>([])
    const livePanelRefs = new Map<string, AgoraLiveInlinePanelRef>()
    const isTsaRoute = computed(() => root.$route.path === '/' + ERouterName.TSA)
    const isLayerRoute = computed(() => root.$route.path === '/' + ERouterName.LAYER)
    const isWaylineRoute = computed(() => root.$route.path === '/' + ERouterName.WAYLINE)
    const isMappingRoute = computed(() => root.$route.path === '/' + ERouterName.MAPPING)
    const isFlightRecordDetailRoute = computed(() => root.$route.name === ERouterName.FLIGHT_RECORD_DETAIL)
    const isMapSettingsRoute = computed(() =>
      isTsaRoute.value || isLayerRoute.value || isWaylineRoute.value || isMappingRoute.value || isFlightRecordDetailRoute.value)
    const mapControlsVisible = computed(() => !props.suspended && (isMapSettingsRoute.value || props.mapControls))
    const mapLocateControlVisible = computed(() => !props.suspended && (isTsaRoute.value || props.mapControls))
    const mapSettingsControlVisible = computed(() => !props.suspended && (isMapSettingsRoute.value || props.mapControls))
    const clientId = computed(() => store.state.clientId)
    const flightControlLoading = ref(false)
    const flightControlActive = ref(false)
    const flightControlFencingToken = ref<number | null>(null)
    const mapSettingsVisible = ref(false)
    const weatherState = reactive({
      loading: false,
      data: null as FlightWeatherData | null,
      error: '',
      dockSn: '',
    })
    let weatherRequestId = 0
    let weatherRefreshTimer: number | undefined
    let browserLocationRequestId = 0
    let cockpitAirportMarker: any = null
    let cockpitAircraftMarker: any = null
    let cockpitFlightTrackLine: any = null
    let cockpitFlightTrackMapPath: GeojsonCoordinate[] = []
    const cockpitFlightTrackWgs84: GeojsonCoordinate[] = []
    let cockpitMapViewportInitialized = false
    let cockpitMapCenterKey = ''
    let cockpitTrackKey = ''
    let cockpitTrackActive = false
    const deviceTopicInfo: DeviceTopicInfo = reactive({
      sn: '',
      pubTopic: '',
      subTopic: ''
    })
    const drcMqttHooks = useMqtt(deviceTopicInfo)
    const drcDroneState = reactive({
      modeCode: null as number | null,
      initialStateSubscribed: false,
      lastUpdateAt: 0,
      lastHeartbeatAt: 0
    })
    const currentDroneSn = computed(() => {
      if (osdVisible.value.is_dock) {
        return deviceInfo.dock.basic_osd?.sub_device?.device_sn || osdVisible.value.sn || ''
      }
      return osdVisible.value.sn || ''
    })
    const dockLiveVisible = computed(() => {
      return hasLiveWindow('dock', osdVisible.value.gateway_sn)
    })
    const droneLiveVisible = computed(() => {
      return hasLiveWindow('drone', currentDroneSn.value)
    })
    const dockLiveWindowId = computed(() => getLiveWindowId('dock', osdVisible.value.gateway_sn))
    const droneLiveWindowId = computed(() => getLiveWindowId('drone', currentDroneSn.value))
    const floatingLiveWindows = computed(() => {
      if (props.mapOnly) {
        return []
      }
      return liveWindows.value.filter(liveWindow => !isLiveWindowEmbedded(liveWindow))
    })
    const selectedDockBasicOsd = computed(() => {
      const dockSn = osdVisible.value.gateway_sn
      return dockSn ? store.state.deviceState.dockInfo[dockSn]?.basic_osd : undefined
    })
    const isDockOffline = computed(() => {
      const basicOsd = selectedDockBasicOsd.value || deviceInfo.dock.basic_osd
      return !basicOsd || basicOsd.mode_code === EDockModeCode.Disconnected
    })
    const dockWeatherLocationKey = computed(() => {
      if (!osdVisible.value.visible || !osdVisible.value.is_dock || !osdVisible.value.gateway_sn) {
        return ''
      }
      const coordinate = resolveValidCoordinate(
        selectedDockBasicOsd.value?.longitude,
        selectedDockBasicOsd.value?.latitude
      )
      if (!coordinate) {
        return `${osdVisible.value.gateway_sn}:invalid`
      }
      return `${osdVisible.value.gateway_sn}:${coordinate.lng.toFixed(2)}:${coordinate.lat.toFixed(2)}`
    })
    const currentAircraftModeCode = computed(() => {
      const osdModeCode = deviceInfo.device?.mode_code
      if (osdModeCode !== undefined && osdModeCode !== EModeCode.Disconnected) {
        return osdModeCode
      }
      if (drcDroneState.modeCode !== null) {
        return drcDroneState.modeCode
      }
      return osdModeCode
    })
    const isSubDevicePoweredOn = computed(() => {
      return deviceInfo.dock.basic_osd?.sub_device?.device_online_status === 1
    })
    const isAircraftOnline = computed(() => {
      const modeCode = currentAircraftModeCode.value
      return (modeCode !== undefined && modeCode !== EModeCode.Disconnected) || isSubDevicePoweredOn.value
    })
    const canOpenDroneLive = computed(() => {
      return !!currentDroneSn.value && isAircraftOnline.value
    })
    const droneLiveButtonDisabled = computed(() => {
      return !droneLiveVisible.value && !canOpenDroneLive.value
    })
    const droneLiveButtonTitle = computed(() => {
      if (droneLiveVisible.value) {
        return '关闭无人机直播'
      }
      return canOpenDroneLive.value ? '开启无人机直播' : '无人机开机后可开启直播'
    })
    const dockRemoteControlActive = computed(() => {
      return deviceInfo.dock.link_osd?.drc_state === DrcStateEnum.CONNECTED
    })
    const isDockRemoteDebugging = computed(() => {
      return deviceInfo.dock.basic_osd?.mode_code === EDockModeCode.Remote_Debugging
    })
    const dockTaskText = computed(() => {
      if (isDockRemoteDebugging.value) {
        return '远程调试中'
      }
      if (flightControlActive.value || dockRemoteControlActive.value) {
        return '远程控制中'
      }
      return '无任务'
    })
    const controlOwnerText = computed(() => {
      return localStorage.getItem(ELocalStorageKey.Username) || str
    })
    const flightControlButtonText = computed(() => {
      return flightControlActive.value ? '退出控制权' : '获取控制权'
    })
    const flightControlButtonTitle = computed(() => {
      return flightControlActive.value ? '退出飞行控制权' : '点击获取飞行控制权'
    })
    const cockpitButtonEnabled = computed(() => {
      return !!osdVisible.value.gateway_sn && !isDockOffline.value
    })
    const cockpitButtonTitle = computed(() => {
      if (!osdVisible.value.gateway_sn) {
        return '请选择机场后进入虚拟座舱'
      }
      if (isDockOffline.value) {
        return '机场离线，无法进入虚拟座舱'
      }
      return '打开虚拟座舱并自动争抢控制权'
    })
    const dockOfflineHint = computed(() => {
      return isDockOffline.value ? '机场离线：仅显示设备信息，直播与控制不可用' : ''
    })
    const dockModelText = computed(() => {
      const modelKey = osdVisible.value.gateway_model_key
      return formatModelName(resolveDeviceModelName(modelKey) || osdVisible.value.gateway_model || 'Dock')
    })
    const aircraftModelText = computed(() => {
      const modelKey = deviceInfo.dock.basic_osd?.sub_device?.device_model_key || osdVisible.value.model_key
      return formatModelName(resolveDeviceModelName(modelKey) || osdVisible.value.model || str)
    })
    const dockModeText = computed(() => {
      const modeCode = deviceInfo.dock.basic_osd?.mode_code
      const dockModeLabels: Record<number, string> = {
        [EDockModeCode.Disconnected]: '机场离线',
        [EDockModeCode.Idle]: '空闲中',
        [EDockModeCode.Debugging]: '现场调试',
        [EDockModeCode.Remote_Debugging]: '远程调试',
        [EDockModeCode.Upgrading]: '固件升级中',
        [EDockModeCode.Working]: '作业中',
        [EDockModeCode.ToBeCalibrated]: '待标定',
      }
      if (modeCode === undefined) {
        // No OSD at all: the dock never came online or was removed on its offline event.
        return dockModeLabels[EDockModeCode.Disconnected]
      }
      return dockModeLabels[modeCode] || EDockModeCode[modeCode] || str
    })
    const dockHealthText = computed(() => {
      return isDockOffline.value ? 'N/A' : '当前正常'
    })
    const flightWeatherEvaluation = computed(() => evaluateFlightWeather({
      offline: isDockOffline.value,
      windSpeedMps: selectedDockBasicOsd.value?.wind_speed,
      rainfall: selectedDockBasicOsd.value?.rainfall,
      temperatureC: selectedDockBasicOsd.value?.environment_temperature,
      humidityPercent: selectedDockBasicOsd.value?.humidity,
    }, weatherState.data, weatherState.data ? '' : (weatherState.loading ? '和风天气加载中' : weatherState.error)))
    const dockFlightText = computed(() => {
      return flightWeatherEvaluation.value.recommended ? '建议起飞' : '不建议起飞'
    })
    const dockMeasuredWindText = computed(() => {
      return formatMeasurement(selectedDockBasicOsd.value?.wind_speed, 'm/s', 1)
    })
    const dockRainfallText = computed(() => {
      const rainfall = selectedDockBasicOsd.value?.rainfall
      const labels: Record<number, string> = {
        [RainfallEnum.NONE]: '无降雨',
        [RainfallEnum.LIGHT_RAIN]: '小雨',
        [RainfallEnum.MODERATE_RAIN]: '中雨',
        [RainfallEnum.HEAVY_RAIN]: '大雨',
      }
      return rainfall === undefined || rainfall === null ? str : (labels[Number(rainfall)] || str)
    })
    const dockMeasuredTemperatureText = computed(() => {
      return formatMeasurement(selectedDockBasicOsd.value?.environment_temperature, '°C', 1)
    })
    const dockMeasuredHumidityText = computed(() => {
      return formatMeasurement(selectedDockBasicOsd.value?.humidity, '%')
    })
    const aircraftModeText = computed(() => {
      const modeCode = currentAircraftModeCode.value
      if ((flightControlActive.value || dockRemoteControlActive.value) && modeCode === EModeCode.Disconnected) {
        if (!drcDroneState.lastHeartbeatAt) {
          return '等待DRC心跳'
        }
        return isSubDevicePoweredOn.value ? '已开机' : (drcDroneState.initialStateSubscribed ? '等待飞控状态' : '开机中')
      }
      if (modeCode === undefined) {
        return isSubDevicePoweredOn.value ? '已开机' : '舱内关机'
      }
      const aircraftModeLabels: Record<number, string> = {
        [EModeCode.Standby]: '待机',
        [EModeCode.Preparing]: '准备中',
        [EModeCode.Ready]: '待命',
        [EModeCode.Manual]: '手动飞行',
        [EModeCode.Automatic]: '自动飞行',
        [EModeCode.Waypoint]: '航线飞行',
        [EModeCode.Panoramic]: '全景拍摄',
        [EModeCode.Active_Track]: '智能跟随',
        [EModeCode.ADS_B]: 'ADS-B',
        [EModeCode.Return_To_Home]: '返航中',
        [EModeCode.Landing]: '降落中',
        [EModeCode.Forced_Landing]: '迫降中',
        [EModeCode.Three_Blades_Landing]: '三桨叶降落',
        [EModeCode.Upgrading]: '升级中',
        [EModeCode.Disconnected]: isSubDevicePoweredOn.value ? '已开机' : '舱内关机',
        15: 'APAS',
        16: '虚拟摇杆状态',
        17: '指令飞行',
      }
      return aircraftModeLabels[modeCode] || EModeCode[modeCode] || str
    })
    const aircraftHealthText = computed(() => {
      return isAircraftOnline.value ? '当前正常' : 'N/A'
    })
    const dockTemperatureText = computed(() => {
      return formatMeasurement(deviceInfo.dock.basic_osd?.environment_temperature, '°C', 1)
    })
    const dockCabinTemperatureText = computed(() => {
      return formatMeasurement(deviceInfo.dock.basic_osd?.temperature, '°C', 1)
    })
    const dockNetworkText = computed(() => {
      const networkState = deviceInfo.dock.basic_osd?.network_state
      if (!networkState) {
        return str
      }
      const networkType = networkState.type === NetworkStateTypeEnum.ETHERNET ? 'ETH' : '4G'
      return `${networkType} ${formatMeasurement(networkState.rate, 'KB/s')}`
    })
    const dockJobText = computed(() => {
      return formatPlainValue(deviceInfo.dock.work_osd?.job_number)
    })
    const sdrQualityText = computed(() => {
      const upQuality = formatPlainValue(deviceInfo.dock.link_osd?.sdr?.up_quality)
      const downQuality = formatPlainValue(deviceInfo.dock.link_osd?.sdr?.down_quality)
      return `${upQuality}/${downQuality}`
    })
    const rtkText = computed(() => {
      return formatPlainValue(pickFirstValue(
        deviceInfo.device?.position_state?.rtk_number,
        deviceInfo.dock.basic_osd?.position_state?.rtk_number,
        deviceInfo.dock.basic_osd?.positionState?.rtk_number
      ))
    })
    const aircraftBatteryText = computed(() => {
      // Aircraft OSD first, dock charger second; both range-checked so a DJI
      // sentinel from either source renders as "--" instead of "32767 %".
      return formatMeasurement(resolveAircraftBatteryPercent(deviceInfo.device, deviceInfo.dock), '%')
    })
    const aircraftAltitudeText = computed(() => {
      return formatMeasurement(deviceInfo.device?.elevation, 'm')
    })
    const aircraftHorizontalSpeedText = computed(() => {
      return formatMeasurement(deviceInfo.device?.horizontal_speed, 'm/s', 1)
    })
    const aircraftHomeText = computed(() => {
      return formatMeasurement(deviceInfo.device?.home_distance, 'm')
    })
    const aircraftWindText = computed(() => {
      return formatMeasurementWithSource(
        pickFirstMeasurement(
          { value: deviceInfo.device?.wind_speed, divisor: 10 },
          { value: deviceInfo.dock.basic_osd?.wind_speed, divisor: 1 }
        ),
        'm/s',
        1
      )
    })
    const qualityStyle = computed(() => {
      if (deviceInfo.dock.basic_osd?.network_state?.type === NetworkStateTypeEnum.ETHERNET ||
        (deviceInfo.dock.basic_osd?.network_state?.quality || 0) > NetworkStateQualityEnum.FAIR) {
        return 'color: #00ee8b'
      }
      if ((deviceInfo.dock.basic_osd?.network_state?.quality || 0) === NetworkStateQualityEnum.FAIR) {
        return 'color: yellow'
      }
      return 'color: red'
    })

    function isBlankValue (value: unknown) {
      return value === undefined || value === null || value === '' || value === str
    }

    function formatPlainValue (value: unknown) {
      return isBlankValue(value) ? str : String(value)
    }

    function pickFirstValue (...values: unknown[]) {
      return values.find(value => !isBlankValue(value))
    }

    function pickFirstMeasurement (...measurements: Array<{ value: unknown, divisor: number }>) {
      return measurements.find(measurement => !isBlankValue(measurement.value))
    }

    function formatMeasurement (value: unknown, unit: string, fractionDigits = 0, divisor = 1) {
      if (isBlankValue(value)) {
        return str
      }
      const numberValue = Number(value)
      if (!Number.isFinite(numberValue)) {
        return str
      }
      return `${(numberValue / divisor).toFixed(fractionDigits)} ${unit}`
    }

    function formatWeatherMeasurement (value: unknown, unit: string, fractionDigits = 0) {
      return formatMeasurement(value, unit, fractionDigits)
    }

    function formatPrecipitation (value: unknown) {
      const numberValue = Number(value)
      if (!Number.isFinite(numberValue)) {
        return str
      }
      return numberValue > 0 ? `${numberValue.toFixed(1)} mm` : '无降水'
    }

    function formatWeatherTime (value: string) {
      const date = new Date(value)
      if (!Number.isFinite(date.getTime())) {
        return str
      }
      return new Intl.DateTimeFormat('zh-CN', {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }).format(date)
    }

    function stopWeatherRefresh () {
      if (weatherRefreshTimer !== undefined) {
        window.clearInterval(weatherRefreshTimer)
        weatherRefreshTimer = undefined
      }
    }

    function resetWeatherState (dockSn = '') {
      weatherRequestId++
      weatherState.loading = false
      weatherState.data = null
      weatherState.error = ''
      weatherState.dockSn = dockSn
    }

    async function refreshDockWeather () {
      if (props.suspended) return
      const dockSn = osdVisible.value.gateway_sn
      const coordinate = resolveValidCoordinate(
        selectedDockBasicOsd.value?.longitude,
        selectedDockBasicOsd.value?.latitude
      )
      if (!dockSn || !coordinate) {
        resetWeatherState(dockSn)
        weatherState.error = '机场经纬度不可用'
        return
      }
      const requestId = ++weatherRequestId
      weatherState.loading = true
      weatherState.error = ''
      weatherState.dockSn = dockSn
      try {
        const response = await getFlightWeather(coordinate.lng, coordinate.lat)
        if (props.suspended || requestId !== weatherRequestId || dockSn !== osdVisible.value.gateway_sn) {
          return
        }
        if (response.code !== 0 || !response.data) {
          weatherState.data = null
          weatherState.error = response.message || '和风天气服务暂时不可用'
          return
        }
        weatherState.data = response.data
      } catch (error: any) {
        if (props.suspended || requestId !== weatherRequestId || dockSn !== osdVisible.value.gateway_sn) {
          return
        }
        weatherState.data = null
        weatherState.error = error?.response?.data?.message || '和风天气服务暂时不可用'
      } finally {
        if (requestId === weatherRequestId) {
          weatherState.loading = false
        }
      }
    }

    function startWeatherRefresh () {
      stopWeatherRefresh()
      const dockSn = osdVisible.value.gateway_sn
      resetWeatherState(dockSn)
      if (props.suspended || !osdVisible.value.visible || !osdVisible.value.is_dock) {
        return
      }
      refreshDockWeather()
      weatherRefreshTimer = window.setInterval(() => {
        refreshDockWeather()
      }, 10 * 60 * 1000)
    }

    function formatMeasurementWithSource (measurement: { value: unknown, divisor: number } | undefined, unit: string, fractionDigits = 0) {
      if (!measurement) {
        return str
      }
      return formatMeasurement(measurement.value, unit, fractionDigits, measurement.divisor)
    }

    function resolveDeviceModelName (modelKey?: string) {
      if (!modelKey) {
        return ''
      }
      const modelNameMap = DEVICE_NAME as Record<string, string>
      if (modelNameMap[modelKey]) {
        return modelNameMap[modelKey]
      }
      return modelKey
    }

    function formatModelName (modelName: string) {
      const normalizedModelName = modelName.replace(/^Dock(\d)$/i, 'Dock $1')
      return normalizedModelName || str
    }

    function resolveValidCoordinate (longitude?: unknown, latitude?: unknown) {
      const lng = Number(longitude)
      const lat = Number(latitude)
      if (!Number.isFinite(lng) || !Number.isFinite(lat)) {
        return null
      }
      if ((lng === 0 && lat === 0) || Math.abs(lng) > 180 || Math.abs(lat) > 90) {
        return null
      }
      return { lng, lat }
    }

    function toCockpitMapCoordinate (coordinate: { lng: number, lat: number }): GeojsonCoordinate {
      const converted = wgs84togcj02(coordinate.lng, coordinate.lat)
      return [converted[0], converted[1]]
    }

    function createCockpitMarker (iconUrl: string, title: string, zIndex: number) {
      const AMap = root.$aMap
      const iconSize = 36
      return new AMap.Marker({
        icon: new AMap.Icon({
          image: iconUrl,
          imageSize: new AMap.Size(iconSize, iconSize),
          size: new AMap.Size(iconSize, iconSize),
        }),
        title,
        offset: new AMap.Pixel(-iconSize / 2, -iconSize / 2),
        zIndex,
      })
    }

    function removeCockpitMarker (marker: any) {
      if (marker && root.$map) {
        root.$map.remove(marker)
      }
    }

    function syncCockpitAirportMarker () {
      if (!props.mapOnly || !root.$map || !root.$aMap) {
        return
      }
      const coordinate = resolveValidCoordinate(props.airportLongitude, props.airportLatitude)
      if (!coordinate) {
        removeCockpitMarker(cockpitAirportMarker)
        cockpitAirportMarker = null
        return
      }
      const mapCoordinate = toCockpitMapCoordinate(coordinate)
      if (!cockpitAirportMarker) {
        cockpitAirportMarker = createCockpitMarker(dockIcon, props.airportName || '机场', 120)
        root.$map.add(cockpitAirportMarker)
      }
      cockpitAirportMarker.setPosition(mapCoordinate)
      cockpitAirportMarker.setTitle(props.airportName || '机场')
    }

    function ensureCockpitFlightTrackLine () {
      if (cockpitFlightTrackLine || !root.$map || !root.$aMap) {
        return
      }
      cockpitFlightTrackLine = new root.$aMap.Polyline({
        path: cockpitFlightTrackMapPath,
        strokeColor: '#00E5A8',
        strokeOpacity: 0.95,
        strokeWeight: COCKPIT_FLIGHT_TRACK_STROKE_WEIGHT,
        strokeStyle: COCKPIT_FLIGHT_TRACK_STROKE_STYLE,
        strokeDasharray: COCKPIT_FLIGHT_TRACK_STROKE_DASHARRAY,
        lineJoin: 'round',
        lineCap: 'round',
        isOutline: true,
        outlineColor: 'rgba(0, 0, 0, 0.65)',
        borderWeight: COCKPIT_FLIGHT_TRACK_OUTLINE_WEIGHT,
        showDir: true,
        zIndex: 80,
      })
      root.$map.add(cockpitFlightTrackLine)
    }

    function appendCockpitFlightTrack (coordinate: { lng: number, lat: number }) {
      if (!cockpitTrackActive) {
        return
      }
      const wgs84Coordinate: GeojsonCoordinate = [coordinate.lng, coordinate.lat]
      if (!appendFlightTrackCoordinate(cockpitFlightTrackWgs84, wgs84Coordinate)) {
        return
      }
      if (cockpitFlightTrackMapPath.length >= COCKPIT_FLIGHT_TRACK_MAX_POINTS) {
        cockpitFlightTrackMapPath.shift()
      }
      cockpitFlightTrackMapPath.push(toCockpitMapCoordinate(coordinate))
      if (cockpitFlightTrackMapPath.length < 2) {
        return
      }
      ensureCockpitFlightTrackLine()
      cockpitFlightTrackLine?.setPath(cockpitFlightTrackMapPath)
    }

    function syncCockpitAircraftMarker () {
      if (!props.mapOnly || !root.$map || !root.$aMap) {
        return
      }
      const coordinate = resolveValidCoordinate(props.aircraftLongitude, props.aircraftLatitude)
      if (!coordinate) {
        removeCockpitMarker(cockpitAircraftMarker)
        cockpitAircraftMarker = null
        return
      }
      const mapCoordinate = toCockpitMapCoordinate(coordinate)
      if (!cockpitAircraftMarker) {
        cockpitAircraftMarker = createCockpitMarker(droneIcon, props.aircraftName || '无人机', 140)
        root.$map.add(cockpitAircraftMarker)
      }
      cockpitAircraftMarker.setPosition(mapCoordinate)
      cockpitAircraftMarker.setTitle(props.aircraftName || '无人机')
      if (Number.isFinite(props.aircraftHeading)) {
        cockpitAircraftMarker.setAngle(((Number(props.aircraftHeading) % 360) + 360) % 360)
      }
      appendCockpitFlightTrack(coordinate)
    }

    function syncCockpitMapViewport () {
      if (!props.mapOnly || !root.$map) {
        return
      }
      const airportCoordinate = resolveValidCoordinate(props.airportLongitude, props.airportLatitude)
      const aircraftCoordinate = resolveValidCoordinate(props.aircraftLongitude, props.aircraftLatitude)
      const selectedCoordinate = selectCockpitMapCenter(
        airportCoordinate ? [airportCoordinate.lng, airportCoordinate.lat] : null,
        aircraftCoordinate ? [aircraftCoordinate.lng, aircraftCoordinate.lat] : null,
        props.followAircraft
      )
      if (!selectedCoordinate) {
        return
      }
      const centerKey = `${props.followAircraft ? 'aircraft' : 'airport'}:${selectedCoordinate[0]}:${selectedCoordinate[1]}`
      if (cockpitMapViewportInitialized && cockpitMapCenterKey === centerKey) {
        return
      }
      root.$map.setCenter(toCockpitMapCoordinate({ lng: selectedCoordinate[0], lat: selectedCoordinate[1] }))
      if (!cockpitMapViewportInitialized) {
        root.$map.setZoom(17, false, 100)
      }
      cockpitMapViewportInitialized = true
      cockpitMapCenterKey = centerKey
    }

    function syncCockpitMapOverlays () {
      if (props.suspended) return
      syncCockpitAirportMarker()
      syncCockpitAircraftMarker()
      syncCockpitMapViewport()
    }

    function resetCockpitFlightTrack () {
      cockpitFlightTrackWgs84.splice(0)
      cockpitFlightTrackMapPath = []
      cockpitFlightTrackLine?.setPath([])
    }

    function removeCockpitMapOverlays () {
      if (root.$map) {
        root.$map.remove([
          cockpitAirportMarker,
          cockpitAircraftMarker,
          cockpitFlightTrackLine,
        ].filter(Boolean))
      }
      cockpitAirportMarker = null
      cockpitAircraftMarker = null
      cockpitFlightTrackLine = null
      resetCockpitFlightTrack()
    }

    function getLatestTsaCoordinate () {
      const deviceState = store.state.deviceState
      if (deviceState.currentType === EDeviceTypeName.Dock) {
        return resolveValidCoordinate(
          deviceState.dockInfo[deviceState.currentSn]?.basic_osd?.longitude,
          deviceState.dockInfo[deviceState.currentSn]?.basic_osd?.latitude
        )
      }
      if (deviceState.currentType === EDeviceTypeName.Aircraft) {
        return resolveValidCoordinate(
          deviceState.deviceInfo[deviceState.currentSn]?.longitude,
          deviceState.deviceInfo[deviceState.currentSn]?.latitude
        )
      }
      if (deviceState.currentType === EDeviceTypeName.Gateway) {
        return resolveValidCoordinate(
          deviceState.gatewayInfo[deviceState.currentSn]?.longitude,
          deviceState.gatewayInfo[deviceState.currentSn]?.latitude
        )
      }
      return null
    }

    function getCurrentTsaCoordinate () {
      if (osdVisible.value.visible) {
        if (osdVisible.value.is_dock) {
          return resolveValidCoordinate(
            deviceInfo.dock?.basic_osd?.longitude ?? store.state.deviceState.dockInfo[osdVisible.value.gateway_sn]?.basic_osd?.longitude,
            deviceInfo.dock?.basic_osd?.latitude ?? store.state.deviceState.dockInfo[osdVisible.value.gateway_sn]?.basic_osd?.latitude
          )
        }
        return resolveValidCoordinate(
          deviceInfo.device?.longitude ?? store.state.deviceState.deviceInfo[osdVisible.value.sn]?.longitude,
          deviceInfo.device?.latitude ?? store.state.deviceState.deviceInfo[osdVisible.value.sn]?.latitude
        )
      }
      return getLatestTsaCoordinate()
    }

    function panToTsaCoordinate (coordinate: { lng: number, lat: number }) {
      if (props.suspended) return
      if (!root.$map) {
        message.warning('地图尚未初始化')
        return
      }
      const gcj02Coordinate = wgs84togcj02(coordinate.lng, coordinate.lat) as GeojsonCoordinate
      root.$map.panTo(gcj02Coordinate, 100)
      root.$map.setZoom(18, false, 100)
    }

    function locateCurrentTsaTarget () {
      const coordinate = resolveValidCoordinate(props.targetLongitude, props.targetLatitude) || getCurrentTsaCoordinate()
      if (!coordinate) {
        message.warning('暂无当前设备位置信息')
        return
      }
      panToTsaCoordinate(coordinate)
    }

    function locateTsaDock (payload: TsaLocateDockPayload) {
      if (!isTsaRoute.value) {
        return
      }
      if (!payload?.dockSn) {
        return
      }
      const coordinate = resolveValidCoordinate(
        store.state.deviceState.dockInfo[payload.dockSn]?.basic_osd?.longitude,
        store.state.deviceState.dockInfo[payload.dockSn]?.basic_osd?.latitude
      )
      if (!coordinate) {
        message.warning('暂无机场位置信息')
        return
      }
      panToTsaCoordinate(coordinate)
    }

    function syncCommonMapControls () {
      const visible = mapControlsVisible.value
      useGMapManageHook.setCommonControlsVisible(visible)
      if (!visible || !mapSettingsVisible.value) {
        mapSettingsVisible.value = false
        useGMapManageHook.setMapTypeControlVisible(false)
      }
    }

    function modelOwnsViewport () {
      return hasMap3DOwner(root.$map)
    }

    function locateMapAtBrowserPosition () {
      const requestId = ++browserLocationRequestId
      const routePath = root.$route.path
      const map = root.$map
      if (props.suspended || !browserLocationMapRoutes.has(routePath) || !map || modelOwnsViewport() || typeof navigator === 'undefined' || !navigator.geolocation) {
        return
      }
      navigator.geolocation.getCurrentPosition(position => {
        if (props.suspended || requestId !== browserLocationRequestId || root.$route.path !== routePath || root.$map !== map || modelOwnsViewport()) {
          return
        }
        const coordinate = resolveValidCoordinate(position.coords.longitude, position.coords.latitude)
        if (!coordinate) {
          return
        }
        const gcj02Coordinate = wgs84togcj02(coordinate.lng, coordinate.lat) as GeojsonCoordinate
        map.setCenter(gcj02Coordinate)
      }, () => {
        // 用户拒绝授权或定位失败时，继续使用地图原有默认中心点。
      }, {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 60000,
      })
    }

    function toggleMapSettings () {
      if (!mapSettingsControlVisible.value) {
        return
      }
      mapSettingsVisible.value = !mapSettingsVisible.value
      useGMapManageHook.setMapTypeControlVisible(mapSettingsVisible.value)
    }

    function resetDrcTopics () {
      deviceTopicInfo.sn = ''
      deviceTopicInfo.pubTopic = ''
      deviceTopicInfo.subTopic = ''
      resetDrcDroneState()
    }

    function resetDrcDroneState () {
      drcDroneState.modeCode = null
      drcDroneState.initialStateSubscribed = false
      drcDroneState.lastUpdateAt = 0
      drcDroneState.lastHeartbeatAt = 0
    }

    function handleDrcMqttInfo (payload: any) {
      if (!deviceTopicInfo.subTopic || !payload?.method) {
        return
      }
      if (payload.method === DRC_METHOD.HEART_BEAT) {
        drcDroneState.lastHeartbeatAt = Date.now()
        return
      }
      if (payload.method === DRC_METHOD.DRC_INITIAL_STATE_SUBSCRIBE) {
        drcDroneState.initialStateSubscribed = payload.data?.result === 0
        return
      }
      if (payload.method === DRC_METHOD.DRC_DRONE_STATE_PUSH) {
        const modeCode = Number(payload.data?.mode_code)
        if (Number.isFinite(modeCode)) {
          drcDroneState.modeCode = modeCode
          drcDroneState.lastUpdateAt = Date.now()
        }
      }
    }

    async function exitLocalFlightControl (showTip: boolean) {
      const dockSn = osdVisible.value.gateway_sn
      if (!clientId.value || !dockSn) {
        return false
      }
      const { code, message: msg } = await postDrcExit({
        client_id: clientId.value,
        dock_sn: dockSn,
        ...(flightControlFencingToken.value === null ? {} : { fencing_token: flightControlFencingToken.value }),
      })
      if (code !== 0) {
        if (showTip) {
          message.error(msg || '退出飞行控制权失败')
        }
        return false
      }
      flightControlActive.value = false
      resetDrcTopics()
      clearDrcControlSession({ clientId: clientId.value, dockSn })
      flightControlFencingToken.value = null
      if (showTip) {
        message.success('已退出飞行控制权')
      }
      return true
    }

    let flightControlOperationPromise: Promise<void> | null = null

    async function runFlightControlToggle () {
      if (flightControlLoading.value) {
        return
      }
      const dockSn = osdVisible.value.gateway_sn
      if (!dockSn) {
        message.warning('缺少机场 SN，无法获取飞行控制权')
        return
      }
      if (!clientId.value) {
        message.warning('控制链路连接中，请稍后重试')
        return
      }
      flightControlLoading.value = true
      let topicsStarted = false
      let sessionAcquired = false
      try {
        if (flightControlActive.value) {
          await exitLocalFlightControl(true)
          return
        }

        resetDrcDroneState()
        const enterResult = await postDrcEnter({
          client_id: clientId.value,
          dock_sn: dockSn,
        })
        if (enterResult.code !== 0) {
          message.error(enterResult.message || '获取飞行控制权失败')
          return
        }
        const enterData = enterResult.data || { sub: [], pub: [] }
        const fencingToken = Number(enterData.fencing_token)
        flightControlFencingToken.value = Number.isFinite(fencingToken) ? fencingToken : null
        setDrcControlSession({
          clientId: clientId.value,
          dockSn,
          fencingToken: flightControlFencingToken.value,
          leaseUntil: Number(enterData.lease_until),
        })
        sessionAcquired = true
        const subTopic = enterData.sub?.[0] || ''
        const pubTopic = enterData.pub?.[0] || ''
        if (!subTopic || !pubTopic) {
          message.error('DRC topic 返回为空，无法建立控制链路')
          await exitLocalFlightControl(false)
          return
        }
        deviceTopicInfo.sn = dockSn
        deviceTopicInfo.subTopic = subTopic
        deviceTopicInfo.pubTopic = pubTopic
        topicsStarted = true
        message.info('已进入指令飞行控制模式，正在等待 DRC 心跳...')
        await nextTick()
        await drcMqttHooks.waitForHeartbeat()
        flightControlActive.value = true
        message.success(isAircraftOnline.value ? 'DRC链路已建立，无人机已开机' : 'DRC链路已建立，正在等待无人机开机')
      } catch (error: any) {
        if (sessionAcquired) {
          await exitLocalFlightControl(false).catch(() => {})
        } else if (topicsStarted) {
          flightControlActive.value = false
          resetDrcTopics()
        }
        message.error(error?.response?.data?.message || error?.message || '飞行控制权操作失败')
      } finally {
        flightControlLoading.value = false
      }
    }

    async function handleDrcLeaseTakenOver (data: any) {
      const dockSn = osdVisible.value.gateway_sn
      if (!shouldInvalidateDrcSession(data, getDrcControlSession(dockSn))) {
        return
      }
      flightControlActive.value = false
      flightControlFencingToken.value = null
      resetDrcTopics()
      clearDrcControlSession()
      const operator = data.operator_username ? `（${data.operator_username}）` : ''
      message.warning(`控制权已被其他操作者${operator}争抢`)
    }

    async function toggleFlightControl () {
      if (flightControlOperationPromise) {
        return flightControlOperationPromise
      }
      const operation = runFlightControlToggle()
      flightControlOperationPromise = operation
      try {
        await operation
      } finally {
        if (flightControlOperationPromise === operation) {
          flightControlOperationPromise = null
        }
      }
    }

    async function openCockpit () {
      const dockSn = osdVisible.value.gateway_sn
      if (!dockSn) {
        message.warning('缺少机场 SN，无法进入虚拟座舱')
        return
      }
      if (isDockOffline.value) {
        message.warning('机场离线，无法进入虚拟座舱')
        return
      }
      const droneSn = currentDroneSn.value
      saveTsaCockpitState({
        dockSn,
        droneSn,
        dockName: osdVisible.value.gateway_callsign || dockModelText.value,
        droneName: osdVisible.value.callsign || aircraftModelText.value,
        osd: {
          ...cloneOsdVisible(osdVisible.value),
          visible: true,
          is_dock: true,
        },
        flightControlActive: false,
      })
      const route = root.$router.resolve({
        path: '/' + ERouterName.COCKPIT,
        query: {
          dock_sn: dockSn,
          drone_sn: droneSn,
          auto_enter: '1',
        }
      })
      const cockpitWindow = window.open('', `dji-cockpit-${dockSn}`)
      if (!cockpitWindow) {
        message.warning('浏览器阻止了虚拟座舱窗口，请允许本站打开新窗口')
        return
      }
      try {
        const existingUrl = new URL(cockpitWindow.location.href)
        if (existingUrl.pathname.endsWith('/' + ERouterName.COCKPIT) && existingUrl.searchParams.get('dock_sn') === dockSn) {
          cockpitWindow.focus()
          return
        }
      } catch (error) {
        // 非同源旧窗口直接复用并导航到当前虚拟座舱。
      }

      if (flightControlOperationPromise) {
        await flightControlOperationPromise
      }
      if (flightControlActive.value || deviceTopicInfo.pubTopic) {
        flightControlLoading.value = true
        try {
          const exited = await exitLocalFlightControl(false)
          if (!exited) {
            message.warning('TSA 控制会话退出失败，虚拟座舱将继续尝试争抢控制权')
          }
        } catch (error: any) {
          message.warning(error?.response?.data?.message || error?.message || 'TSA 控制会话退出失败，虚拟座舱将继续尝试争抢控制权')
        } finally {
          flightControlActive.value = false
          resetDrcTopics()
          flightControlLoading.value = false
        }
      }
      if (cockpitWindow.closed) {
        return
      }
      cockpitWindow.location.replace(route.href)
      cockpitWindow.focus()
    }

    // Keep shared device/cover reconciliation active while the map is hidden:
    // these handlers also consume offline events and update live control state.
    watch(() => store.state.deviceStatusEvent,
      data => {
        if (props.mapOnly) {
          return
        }
        if (Object.keys(data.deviceOnline).length !== 0) {
          deviceTsaUpdateHook.initMarker(data.deviceOnline.domain, data.deviceOnline.device_callsign, data.deviceOnline.sn)
          store.state.deviceStatusEvent.deviceOnline = {} as DeviceStatus
        }
        if (Object.keys(data.deviceOffline).length !== 0) {
          const offlineSn = data.deviceOffline.sn
          deviceTsaUpdateHook.removeMarker(offlineSn)
          closeLiveWindowsByTargetSn(offlineSn)
          if (osdVisible.value.is_dock) {
            // The dock panel stays open so an offline dock can still be inspected;
            // SET_DEVICE_OFFLINE already dropped its OSD, so only the mirror and
            // the control panel (whose commands need the dock) are reset.
            if (offlineSn === osdVisible.value.gateway_sn || offlineSn === osdVisible.value.sn) {
              syncSelectedDeviceMirror()
              if (offlineSn === osdVisible.value.gateway_sn) {
                setDockControlPanelVisible(false)
              }
            }
          } else if (offlineSn === osdVisible.value.sn) {
            closeOsdPanel()
          }
          store.state.deviceStatusEvent.deviceOffline = {}
        }
      },
      {
        deep: true
      }
    )

    watch(() => store.state.deviceState, data => {
      if (props.mapOnly) {
        return
      }
      if (data.currentType === EDeviceTypeName.Gateway && data.gatewayInfo[data.currentSn]) {
        const coordinate = wgs84togcj02(data.gatewayInfo[data.currentSn].longitude, data.gatewayInfo[data.currentSn].latitude)
        deviceTsaUpdateHook.moveTo(data.currentSn, coordinate[0], coordinate[1])
      }
      if (data.currentType === EDeviceTypeName.Aircraft && data.deviceInfo[data.currentSn]) {
        const coordinate = wgs84togcj02(data.deviceInfo[data.currentSn].longitude, data.deviceInfo[data.currentSn].latitude)
        deviceTsaUpdateHook.moveTo(data.currentSn, coordinate[0], coordinate[1])
      }
      if (data.currentType === EDeviceTypeName.Dock && data.dockInfo[data.currentSn]) {
        const coordinate = wgs84togcj02(data.dockInfo[data.currentSn].basic_osd?.longitude, data.dockInfo[data.currentSn].basic_osd?.latitude)
        deviceTsaUpdateHook.initMarker(EDeviceTypeName.Dock, EDeviceTypeName[EDeviceTypeName.Dock], data.currentSn, coordinate[0], coordinate[1])
      }
      syncSelectedDeviceMirror()
    }, {
      deep: true
    })

    // Mirror the selected target's OSD into the panel state. Re-resolving from
    // the store on every target change drops the previous dock's telemetry and
    // keeps `deviceInfo.dock` an object even when the selected dock is offline.
    function syncSelectedDeviceMirror () {
      if (props.mapOnly) {
        return
      }
      const mirror = resolveSelectedOsdMirror(store.state.deviceState, osdVisible.value, osdMirrorDefaults)
      deviceInfo.dock = mirror.dock
      deviceInfo.device = mirror.device as DeviceOsd
      deviceInfo.gateway = mirror.gateway
    }

    watch(
      () => [osdVisible.value.visible, osdVisible.value.is_dock, osdVisible.value.gateway_sn, osdVisible.value.sn],
      () => syncSelectedDeviceMirror(),
      { immediate: true }
    )

    watch(
      () => store.state.wsEvent,
      newData => {
        const useGMapCoverHook = useGMapCover()
        const event = newData
        let exist = false
        if (Object.keys(event.mapElementCreat).length !== 0) {
          console.log(event.mapElementCreat)
          const ele = event.mapElementCreat
          store.state.Layers.forEach(layer => {
            layer.elements.forEach(e => {
              if (e.id === ele.id) {
                exist = true
                console.log('true')
              }
            })
          })
          if (exist === false) {
            const mapElement = transformMapElementCoordinates({
              id: ele.id,
              name: ele.name,
              resource: ele.resource
            }, 'wgs84-gcj02')
            setLayers(mapElement as PostElementsBody, ele.group_id || ele.groupId)

            const data = { id: mapElement.id, name: mapElement.name }
            if (MapElementEnum.PIN === mapElement.resource?.type) {
              useGMapCoverHook.init2DPin(
                mapElement.name,
                mapElement.resource.content.geometry.coordinates,
                mapElement.resource.content.properties.color,
                data
              )
            } else if (MapElementEnum.LINE === mapElement.resource?.type) {
              useGMapCoverHook.initPolyline(
                mapElement.name,
                mapElement.resource.content.geometry.coordinates,
                mapElement.resource.content.properties.color,
                data)
            } else if (MapElementEnum.POLY === mapElement.resource?.type) {
              useGMapCoverHook.initPolygon(
                mapElement.name,
                mapElement.resource.content.geometry.coordinates,
                mapElement.resource.content.properties.color,
                data)
            }
          }

          store.state.wsEvent.mapElementCreat = {}
        }
        if (Object.keys(event.mapElementUpdate).length !== 0) {
          console.log(event.mapElementUpdate)
          console.log('该功能还未实现，请开发商自己增加')
          store.state.wsEvent.mapElementUpdate = {}
        }
        if (Object.keys(event.mapElementDelete).length !== 0) {
          console.log(event.mapElementDelete)
          console.log('该功能还未实现，请开发商自己增加')
          store.state.wsEvent.mapElementDelete = {}
        }
      },
      {
        deep: true
      }
    )

    function draw (type: MapDoodleType, bool: boolean, flightAreaType?: EFlightAreaType) {
      const isMapElementDraw = [MapDoodleEnum.PIN, MapDoodleEnum.POLYLINE, MapDoodleEnum.POLYGON].includes(type as any)
      if (isLayerRoute.value && bool && isMapElementDraw && !flightAreaType && !store.state.selectedMapElementGroupId) {
        message.warning('请先选择一个目录')
        return
      }
      state.currentType = type
      mouseMode.value = bool
      state.isFlightArea = !!flightAreaType
      useMouseToolHook.mouseTool(type, getDrawCallback, flightAreaType)
    }

    // dock 控制面板
    const {
      dockControlPanelVisible,
      setDockControlPanelVisible,
      onCloseControlPanel
    } = useDockControl()

    // 连接或断开drc
    if (!props.mapOnly) {
      useConnectMqtt()
    }

    watch(
      () => [props.suspended, osdVisible.value.visible, osdVisible.value.is_dock, dockWeatherLocationKey.value],
      () => startWeatherRefresh(),
      { immediate: true }
    )

    watch(
      () => [
        props.airportLongitude,
        props.airportLatitude,
        props.airportName,
        props.aircraftLongitude,
        props.aircraftLatitude,
        props.aircraftHeading,
        props.aircraftName,
        props.followAircraft,
      ],
      () => syncCockpitMapOverlays()
    )

    watch(() => props.flightTrackActive, active => {
      if (active && !cockpitTrackActive) {
        resetCockpitFlightTrack()
      }
      cockpitTrackActive = active
      if (active) {
        syncCockpitMapOverlays()
      }
    }, { immediate: true })

    watch(() => props.flightTrackKey, key => {
      if (key === cockpitTrackKey) {
        return
      }
      cockpitTrackKey = key
      cockpitMapViewportInitialized = false
      cockpitMapCenterKey = ''
      resetCockpitFlightTrack()
      syncCockpitMapOverlays()
    }, { immediate: true })

    onMounted(async () => {
      const app = getApp()
      await useGMapManageHook.globalPropertiesConfig(app)
      if (root.$map && root.$aMap) {
        EventBus.emit('gMapReady')
      }
      if (props.mapOnly) {
        useGMapManageHook.setDefaultSatelliteLayer()
        syncCockpitMapOverlays()
      }
      locateMapAtBrowserPosition()
      syncCommonMapControls()
      restoreTsaLiveWindow()
      EventBus.on('droneControlMqttInfo', handleDrcMqttInfo)
      EventBus.on('tsaLocateDock', locateTsaDock)
      EventBus.on('drcLeaseTakenOver', handleDrcLeaseTakenOver)
    })

    onBeforeUnmount(() => {
      browserLocationRequestId++
      weatherRequestId++
      stopWeatherRefresh()
      removeCockpitMapOverlays()
      mapSettingsVisible.value = false
      useGMapManageHook.setMapTypeControlVisible(false)
      useGMapManageHook.setCommonControlsVisible(false)
      EventBus.off('droneControlMqttInfo', handleDrcMqttInfo)
      EventBus.off('tsaLocateDock', locateTsaDock)
      EventBus.off('drcLeaseTakenOver', handleDrcLeaseTakenOver)
    })

    watch(() => [root.$route.path, props.suspended], () => {
      // Invalidate geolocation from a previously visible map, including a quick
      // suspend/resume on the same route. Business MQTT/DRC sessions stay alive.
      browserLocationRequestId++
      syncCommonMapControls()
      if (props.suspended) return
      root.$map?.resize?.()
      locateMapAtBrowserPosition()
      syncCockpitMapOverlays()
      restoreTsaLiveWindow()
    }, { flush: 'post' })

    const { getDrawFlightAreaCallback, onFlightAreaDroneLocationWs } = useFlightArea()
    useFlightAreaDroneLocationEvent(onFlightAreaDroneLocationWs)

    function selectFlightAreaAction ({ type, isCircle }: { type: EFlightAreaType, isCircle: boolean }) {
      draw(isCircle ? MapDoodleEnum.CIRCLE : MapDoodleEnum.POLYGON, true, type)
    }

    function getDrawCallback ({ obj }: { obj : any }) {
      if (state.isFlightArea) {
        getDrawFlightAreaCallback(obj)
        return
      }
      switch (state.currentType) {
        case MapDoodleEnum.PIN:
          postPinPositionResource(obj)
          break
        case MapDoodleEnum.POLYLINE:
          postPolylineResource(obj)
          break
        case MapDoodleEnum.POLYGON:
          postPolygonResource(obj)
          break
        default:
          break
      }
    }
    async function postPinPositionResource (obj) {
      const req = getPinPositionResource(obj)
      await persistMapElementResource(obj, req as PostElementsBody)
    }
    async function postPolylineResource (obj) {
      const req = getPolylineResource(obj)
      await persistMapElementResource(obj, req as PostElementsBody)
    }
    async function postPolygonResource (obj) {
      const req = getPoygonResource(obj)
      await persistMapElementResource(obj, req as PostElementsBody)
    }

    async function persistMapElementResource (obj: any, req: PostElementsBody) {
      obj.setExtData({ id: req.id, name: req.name })
      if (isLayerRoute.value) {
        EventBus.emit('mapElementDraftCreated', { element: req, overlay: obj })
        draw(MapDoodleEnum.Close, false)
        return
      }

      setLayers(req)
      store.state.coverMap[req.id] = [obj]
      const apiReq = transformMapElementCoordinates(req, 'gcj02-wgs84')
      try {
        const result = await postElementsReq(shareId.value, apiReq)
        if (result.code !== 0) {
          rollbackMapElementResource(req.id, obj)
        }
      } catch {
        rollbackMapElementResource(req.id, obj)
      }
    }

    function rollbackMapElementResource (id: string, obj: any) {
      const layers = store.state.Layers.map(layer => ({
        ...layer,
        elements: layer.elements?.filter(element => element.id !== id) || []
      }))
      store.commit('SET_LAYER_INFO', layers)
      delete store.state.coverMap[id]
      root.$map.remove(obj)
    }

    function getPinPositionResource (obj) {
      const position = obj.getPosition()
      const resource = generatePointContent(position)
      const name = obj._originOpts.title
      const id = uuidv4()
      return {
        id,
        name,
        resource
      }
    }
    function getPolylineResource (obj) {
      const path = obj.getPath()
      const resource = generateLineContent(path)
      const { name, id } = getBaseInfo(obj._opts)
      return {
        id,
        name,
        resource
      }
    }
    function getPoygonResource (obj) {
      const path = obj.getPath()
      const resource = generatePolyContent(path)
      const { name, id } = getBaseInfo(obj._opts)
      return {
        id,
        name,
        resource
      }
    }
    function getBaseInfo (obj) {
      const name = obj.title
      const id = uuidv4()
      return { name, id }
    }
    function setLayers (resource: PostElementsBody, groupId = shareId.value) {
      const layers = store.state.Layers
      const layer = layers.find(item => item.id === groupId)
      // layer.id = 'private_layer' + uuidv4()
      // layer?.elements.push(resource)
      if (layer?.elements && !layer.elements.some(element => element.id === resource.id)) {
        ;(layer?.elements as any[]).push(resource)
      }
      console.log('layers', layers)
      store.commit('SET_LAYER_INFO', layers)
    }
    function closeLivestreamOthers () {
      store.commit('SET_LIVESTREAM_OTHERS_VISIBLE', false)
    }
    function closeLivestreamAgora () {
      store.commit('SET_LIVESTREAM_AGORA_VISIBLE', false)
    }
    function cloneOsdVisible (osd: OSDVisible): OSDVisible {
      return {
        ...osd,
        payloads: osd.payloads ? osd.payloads.map(payload => ({ ...payload })) : null,
      }
    }
    function closeOsdPanel () {
      store.commit('SET_OSD_VISIBLE_INFO', {
        ...cloneOsdVisible(osdVisible.value),
        visible: false,
      })
      setDockControlPanelVisible(false)
      clearTsaOsdState()
    }
    function toggleDockControlPanel () {
      setDockControlPanelVisible(!dockControlPanelVisible.value)
    }
    function getLiveWindowId (type: LiveWindowType, targetSn: string) {
      return `${type}:${targetSn}`
    }
    function hasLiveWindow (type: LiveWindowType, targetSn: string) {
      return !!targetSn && liveWindows.value.some(liveWindow => liveWindow.id === getLiveWindowId(type, targetSn))
    }
    function isLiveWindowEmbedded (liveWindow: LiveWindow) {
      if (!osdVisible.value.visible || !osdVisible.value.is_dock) {
        return false
      }
      if (liveWindow.type === 'dock') {
        return liveWindow.targetSn === osdVisible.value.gateway_sn
      }
      return liveWindow.type === 'drone' && liveWindow.targetSn === currentDroneSn.value
    }
    function persistLiveWindows () {
      const activeLiveWindows = liveWindows.value.filter(liveWindow => liveWindow.liveState)
      if (activeLiveWindows.length === 0) {
        clearTsaLiveWindowState()
        return
      }
      saveTsaLiveWindowsState(activeLiveWindows.map(liveWindow => ({
        type: liveWindow.type,
        targetSn: liveWindow.targetSn,
        gatewaySn: liveWindow.gatewaySn,
        title: liveWindow.title,
        liveState: liveWindow.liveState,
      })))
    }
    function setLiveWindow (type: LiveWindowType, targetSn: string, title: string, liveState: boolean, gatewaySn?: string) {
      if (!targetSn) {
        return
      }
      const id = getLiveWindowId(type, targetSn)
      const existingLiveWindow = liveWindows.value.find(liveWindow => liveWindow.id === id)
      if (existingLiveWindow) {
        existingLiveWindow.title = title
        existingLiveWindow.gatewaySn = gatewaySn || existingLiveWindow.gatewaySn
        existingLiveWindow.liveState = existingLiveWindow.liveState || liveState
        persistLiveWindows()
        return
      }
      liveWindows.value.push({
        id,
        type,
        targetSn,
        gatewaySn,
        title,
        liveState,
      })
      persistLiveWindows()
    }
    function openLiveWindow (type: LiveWindowType, targetSn: string, title: string, gatewaySn?: string) {
      setLiveWindow(type, targetSn, title, false, gatewaySn)
    }
    function setLivePanelRef (id: string) {
      return (instance: AgoraLiveInlinePanelRef | null) => {
        if (instance) {
          livePanelRefs.set(id, instance)
          return
        }
        window.setTimeout(() => {
          if (!liveWindows.value.some(liveWindow => liveWindow.id === id)) {
            livePanelRefs.delete(id)
          }
        })
      }
    }
    async function closeLiveWindow (id: string) {
      if (!await ensureAliyunLiveExitAllowed()) {
        return
      }
      const livePanel = livePanelRefs.get(id)
      if (livePanel?.stopLive) {
        await livePanel.stopLive().catch(error => console.error(error))
      }
      livePanelRefs.delete(id)
      liveWindows.value = liveWindows.value.filter(liveWindow => liveWindow.id !== id)
      persistLiveWindows()
    }
    function closeLiveWindowsByTargetSn (targetSn: string) {
      const closingLiveWindows = liveWindows.value.filter(liveWindow => liveWindow.targetSn === targetSn || liveWindow.gatewaySn === targetSn)
      if (closingLiveWindows.length === 0) {
        return
      }
      closingLiveWindows.forEach(liveWindow => closeLiveWindow(liveWindow.id))
    }
    function restoreTsaLiveWindow () {
      if (!isTsaRoute.value) {
        return
      }
      const tsaPageState = getTsaPageState()
      const savedLiveWindows = tsaPageState?.liveWindows?.length ? tsaPageState.liveWindows : (tsaPageState?.liveWindow ? [tsaPageState.liveWindow] : [])
      if (savedLiveWindows.length === 0) {
        return
      }
      savedLiveWindows.forEach(savedLiveWindow => {
        if (savedLiveWindow.liveState && savedLiveWindow.targetSn) {
          setLiveWindow(
            savedLiveWindow.type,
            savedLiveWindow.targetSn,
            savedLiveWindow.title || (savedLiveWindow.type === 'dock' ? '机场直播' : '无人机直播'),
            true,
            savedLiveWindow.gatewaySn || (savedLiveWindow.type === 'dock' ? savedLiveWindow.targetSn : undefined)
          )
        }
      })
    }
    function onLiveStateChange (id: string, liveState: boolean) {
      const targetLiveWindow = liveWindows.value.find(liveWindow => liveWindow.id === id)
      if (!targetLiveWindow) {
        return
      }
      targetLiveWindow.liveState = liveState
      persistLiveWindows()
    }
    function toggleDockLive () {
      if (dockLiveVisible.value) {
        closeLiveWindow(getLiveWindowId('dock', osdVisible.value.gateway_sn))
        return
      }
      openLiveWindow('dock', osdVisible.value.gateway_sn, '机场直播', osdVisible.value.gateway_sn)
    }
    function toggleDroneLive () {
      if (droneLiveVisible.value) {
        closeLiveWindow(getLiveWindowId('drone', currentDroneSn.value))
        return
      }
      if (!canOpenDroneLive.value) {
        message.warning('无人机开机后可开启直播')
        return
      }
      openLiveWindow('drone', currentDroneSn.value, '无人机直播', osdVisible.value.gateway_sn)
    }
    function getLiveWindowStyle (index: number) {
      return {
        '--tsa-live-window-offset': `${(index % 6) * 28}px`,
        zIndex: 20 + index,
      }
    }
    return {
      draw,
      mouseMode,
      drawVisible,
      livestreamOthersVisible,
      livestreamAgoraVisible,
      osdVisible,
      pin,
      state,
      M30,
      dockIcon,
      deviceInfo,
      EGear,
      EModeCode,
      str,
      EDockModeCode,
      dockControlPanelVisible,
      setDockControlPanelVisible,
      onCloseControlPanel,
      NetworkStateTypeEnum,
      NetworkStateQualityEnum,
      closeLivestreamOthers,
      closeLivestreamAgora,
      closeOsdPanel,
      toggleDockControlPanel,
      liveWindows,
      floatingLiveWindows,
      closeLiveWindow,
      setLivePanelRef,
      dockLiveVisible,
      dockLiveWindowId,
      droneLiveVisible,
      droneLiveWindowId,
      droneLiveButtonDisabled,
      droneLiveButtonTitle,
      currentDroneSn,
      toggleDockLive,
      toggleDroneLive,
      onLiveStateChange,
      getLiveWindowStyle,
      isTsaRoute,
      isLayerRoute,
      isWaylineRoute,
      isMappingRoute,
      isFlightRecordDetailRoute,
      isMapSettingsRoute,
      mapLocateControlVisible,
      mapSettingsControlVisible,
      locateCurrentTsaTarget,
      mapSettingsVisible,
      toggleMapSettings,
      qualityStyle,
      isDockOffline,
      isAircraftOnline,
      dockRemoteControlActive,
      isDockRemoteDebugging,
      cockpitButtonEnabled,
      cockpitButtonTitle,
      dockOfflineHint,
      openCockpit,
      flightControlActive,
      flightControlLoading,
      flightControlButtonText,
      flightControlButtonTitle,
      controlOwnerText,
      toggleFlightControl,
      dockTaskText,
      dockModelText,
      aircraftModelText,
      dockModeText,
      dockHealthText,
      dockFlightText,
      flightWeatherEvaluation,
      weatherState,
      dockMeasuredWindText,
      dockRainfallText,
      dockMeasuredTemperatureText,
      dockMeasuredHumidityText,
      formatWeatherMeasurement,
      formatPrecipitation,
      formatWeatherTime,
      aircraftModeText,
      aircraftHealthText,
      dockTemperatureText,
      dockCabinTemperatureText,
      dockNetworkText,
      dockJobText,
      sdrQualityText,
      rtkText,
      aircraftBatteryText,
      aircraftAltitudeText,
      aircraftHorizontalSpeedText,
      aircraftHomeText,
      aircraftWindText,
      selectFlightAreaAction,
    }
  }
})
</script>

<style lang="scss" scoped>

.g-map-wrapper {
  height: 100%;
  width: 100%;
  position: relative;

  .g-action-panel {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 8;
    padding: 4px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
    .g-action-item {
      width: 32px;
      height: 32px;
      background: transparent;
      color: $primary;
      border-radius: 3px;
      line-height: 32px;
      text-align: center;
      margin-bottom: 1px;
      transition: background 0.16s ease, color 0.16s ease;
    }
    .g-action-item:hover {
      border: 0;
      color: #fff;
      background: $primary;
    }
    .g-action-item.selection {
      color: #fff;
      background: $primary;
    }
  }
  .tsa-map-locate-control,
  .map-settings-control {
    position: absolute;
    bottom: 18px;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    color: #1f2933;
    font-size: 18px;
    line-height: 1;
    font-family: inherit;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.14);
    border-radius: 3px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.24);
    cursor: pointer;
    appearance: none;
  }
  .tsa-map-locate-control {
    right: 64px;
  }
  .map-settings-control {
    right: 104px;
  }
  .map-settings-control--compact {
    right: 64px;
  }
  .tsa-map-locate-control:hover,
  .map-settings-control:hover,
  .map-settings-control--active {
    color: $primary;
    border-color: $primary;
  }
  #g-container {
    :deep(.amap-toolbar) {
      top: auto !important;
      right: 16px !important;
      bottom: 18px !important;
      left: auto !important;
      z-index: 8 !important;
    }
    :deep(.amap-controlbar) {
      top: auto !important;
      right: 16px !important;
      bottom: 112px !important;
      left: auto !important;
      z-index: 8 !important;
    }
    :deep(.amap-maptype),
    :deep(.amap-maptypecontrol) {
      top: auto !important;
      right: 112px !important;
      bottom: 220px !important;
      left: auto !important;
      z-index: 8 !important;
    }
  }
  .selection {
    border: 1px solid $primary;
    border-radius: 2px;
  }

  // antd button 光晕
  &:deep(.ant-btn){
    &::after {
      display: none;
    }
  }
}
.osd-panel {
  position: absolute;
  margin-left: 10px;
  left: 0;
  top: 10px;
  z-index: 10;
  width: 480px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.82);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 4px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.45);
  overflow: visible;
}
.osd-panel__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 40px;
  padding: 0 12px;
  color: #fff;
  background: #232323;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px 4px 0 0;
  user-select: none;
}
.osd-panel__heading {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 700;
}
.osd-panel__serials {
  display: grid;
  gap: 4px;
  padding: 8px 12px;
  color: #dce5ef;
  background: rgba(0, 0, 0, 0.22);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  user-select: text;
  cursor: text;
}
.osd-panel__serial-item {
  display: grid;
  grid-template-columns: 72px minmax(0, 1fr);
  gap: 8px;
  align-items: start;
  line-height: 18px;
}
.osd-panel__serial-label {
  color: #8ea0b4;
  font-weight: 700;
  white-space: nowrap;
}
.osd-panel__serial-value {
  color: #fff;
  font-family: Menlo, Monaco, Consolas, 'Courier New', monospace;
  word-break: break-all;
  overflow-wrap: anywhere;
  white-space: normal;
}
.osd-action-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.osd-panel--dock {
  width: 405px;
  background: #202020;
  border: 2px solid #168bff;
  border-radius: 0;
  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.46);
  overflow: visible;
}
.dock-panel__title {
  display: grid;
  grid-template-columns: 54px 34px minmax(0, 1fr) 28px;
  align-items: stretch;
  height: 38px;
  color: #fff;
  background: #202020;
  border-bottom: 1px solid #414141;
  user-select: none;
}
.dock-panel__task {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  color: #f3f3f3;
  font-size: 10px;
  line-height: 1;
  white-space: nowrap;
  background: #303030;
  border-right: 1px solid #414141;
}
.dock-panel__task--debugging {
  color: #ffad0a;
  font-weight: 700;
  background: #282828;
  box-shadow: inset 0 -2px 0 rgba(255, 173, 10, 0.75);
}
.dock-panel__task--control {
  color: #d9ecff;
  font-weight: 700;
  background: #1f4d73;
}
.dock-panel__split {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f0f0f0;
  font-weight: 700;
  border-right: 1px solid #414141;
}
.dock-panel__heading {
  display: flex;
  align-items: center;
  min-width: 0;
  padding: 0 12px;
  overflow: hidden;
  color: #fff;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dock-panel__content {
  display: grid;
  grid-template-columns: 54px minmax(0, 1fr);
  min-height: 192px;
  border-bottom: 1px solid #363636;
}
.dock-panel__rail {
  display: flex;
  flex-direction: column;
  background: #333;
}
.dock-panel__rail--remote-debug .dock-panel__device {
  padding: 3px 0;
  border: 4px solid transparent;
  border-image: repeating-linear-gradient(
    135deg,
    #f2cb05 0,
    #f2cb05 5px,
    #151515 5px,
    #151515 10px
  ) 4;
}
.dock-panel__device {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 96px;
  padding: 6px 3px;
  color: #fff;
  font-size: 12px;
  line-height: 16px;
  font-family: inherit;
  box-sizing: border-box;
  background: #333;
  border: 0;
  border-bottom: 1px solid #3d3d3d;
  cursor: default;
}
.dock-panel__device--active {
  background: #3d3d3d;
}
.dock-panel__device--muted {
  color: #878787;
  background: #303030;
}
.dock-panel__device-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 42px;
  margin-bottom: 4px;
}
.dock-panel__device-icon :deep(.ant-image),
.dock-panel__device-icon :deep(.ant-image-img) {
  width: 34px;
  height: 34px;
  object-fit: contain;
}
.dock-panel__device-icon--aircraft :deep(.ant-image),
.dock-panel__device-icon--aircraft :deep(.ant-image-img) {
  width: 44px;
  height: 32px;
  opacity: 0.52;
}
.dock-panel__device-name {
  width: 100%;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dock-panel__main {
  min-width: 0;
}
.dock-panel__section {
  position: relative;
  padding: 9px 8px 7px;
}
.dock-panel__section--dock {
  min-height: 96px;
  border-bottom: 1px solid #363636;
}
.dock-panel__section--aircraft {
  min-height: 96px;
}
.dock-panel__status-row {
  display: grid;
  grid-template-columns: 105px minmax(0, 1fr);
  gap: 8px;
  align-items: center;
  min-height: 22px;
  margin-bottom: 3px;
}
.dock-panel__status {
  overflow: hidden;
  color: #00d781;
  font-weight: 700;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dock-panel__status--offline {
  color: #8b8b8b;
}
.dock-panel__offline-hint {
  margin: 0 0 6px;
  color: #f2d299;
  font-size: 12px;
  line-height: 18px;
}
.dock-panel__pill {
  display: block;
  min-width: 0;
  height: 20px;
  padding: 0 8px;
  overflow: hidden;
  color: #fff;
  font-weight: 700;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #666;
}
.dock-panel__telemetry {
  display: grid;
  grid-template-columns: 1.15fr 0.9fr 0.9fr 1.15fr 0.55fr;
  gap: 5px;
  align-items: center;
  min-height: 20px;
  margin-bottom: 4px;
}
.dock-panel__metric {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  min-width: 0;
  overflow: hidden;
  color: #fff;
  font-weight: 700;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dock-panel__metric--danger {
  color: #ff4d4f;
  font-weight: 700;
}
.dock-panel__metric-mark {
  font-size: 15px;
  line-height: 1;
}
.flight-weather-card {
  width: 470px;
  max-width: calc(100vw - 32px);
  color: #f5f5f5;
  font-size: 12px;
  background: #080808;
}
.flight-weather-card__recommendation {
  padding: 12px 14px 10px;
  color: #73d13d;
  background: #111;
  border-bottom: 1px solid #303030;
}
.flight-weather-card__recommendation > strong {
  display: block;
  margin-bottom: 4px;
  font-size: 15px;
}
.flight-weather-card__recommendation--danger {
  color: #ff7875;
}
.flight-weather-card__reasons {
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: #ffccc7;
  line-height: 18px;
}
.flight-weather-card__section {
  padding: 10px 14px 11px;
  border-bottom: 1px solid #282828;
}
.flight-weather-card__section h4 {
  margin: 0 0 9px;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  line-height: 20px;
}
.flight-weather-card__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px 12px;
}
.flight-weather-card__grid--four {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.flight-weather-card__item {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 1px;
  text-align: center;
}
.flight-weather-card__item strong {
  overflow: hidden;
  color: #fff;
  font-size: 13px;
  line-height: 19px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.flight-weather-card__item span {
  overflow: hidden;
  color: #858585;
  line-height: 17px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.flight-weather-card__forecast + .flight-weather-card__forecast {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #303030;
}
.flight-weather-card__forecast-time {
  margin-bottom: 7px;
  color: #bfbfbf;
  font-weight: 700;
  line-height: 18px;
}
.flight-weather-card__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 68px;
  padding: 12px 14px;
  color: #bfbfbf;
  border-bottom: 1px solid #282828;
}
.flight-weather-card__loading {
  animation: dock-panel-spin 1s linear infinite;
}
.flight-weather-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 34px;
  padding: 7px 14px;
  color: #777;
  line-height: 18px;
}
.flight-weather-card__footer a {
  color: #40a9ff;
}
:global(.tsa-flight-weather-popover) {
  max-width: none;
}
:global(.tsa-flight-weather-popover .ant-popover-inner) {
  overflow: hidden;
  background: #080808;
  border: 1px solid #303030;
  border-radius: 2px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.62);
}
:global(.tsa-flight-weather-popover .ant-popover-inner-content) {
  padding: 0;
}
:global(.tsa-flight-weather-popover .ant-popover-arrow-content) {
  background: #080808;
}
.dock-panel__actions,
.dock-panel__camera-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 24px;
  gap: 6px;
  align-items: center;
}
.dock-panel__camera-row {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 76px;
  margin-bottom: 6px;
}
.dock-panel__action,
.dock-panel__icon-action {
  height: 24px;
  padding: 0 8px;
  overflow: hidden;
  color: #fff;
  font-size: 12px;
  line-height: 22px;
  font-family: inherit;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #242424;
  border: 1px solid #616161;
  border-radius: 1px;
  cursor: pointer;
}
.dock-panel__action--wide {
  width: 100%;
}
.dock-panel__action--active,
.dock-panel__icon-action--active {
  border-color: #168bff;
  box-shadow: inset 3px 0 0 #168bff;
}
.dock-panel__action--ghost,
.dock-panel__action:disabled,
.dock-panel__icon-action:disabled {
  color: #8b8b8b;
  background: #262626;
  border-color: #4b4b4b;
  cursor: not-allowed;
}
.dock-panel__icon-action {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  padding: 0;
  font-size: 15px;
}
.dock-panel__control-action {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  font-size: 12px;
}
.dock-panel__loading {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.dock-panel__loading-icon {
  animation: dock-panel-spin 1s linear infinite;
}
@keyframes dock-panel-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.dock-panel__cockpit {
  margin-top: 0;
  color: #fff;
  background: #3e3e3e;
  border-color: #3e3e3e;
  cursor: default;
}
.dock-panel__cockpit--enabled {
  background: #3e3e3e;
  border-color: #535353;
  box-shadow: none;
  cursor: pointer;
}
.dock-panel__cockpit--enabled:hover {
  background: #484848;
  border-color: #6a6a6a;
}
.dock-panel__live-stack {
  background: #050505;
  border-bottom: 1px solid #363636;
}
.dock-panel__live-stack :deep(.agora-inline) {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  background: #050505;
  border: 0;
  border-radius: 0;
}
.dock-panel__live-stack :deep(.agora-inline__header) {
  min-height: 28px;
  margin: 0;
  padding: 0 8px;
  color: #fff;
  background: #050505;
}
.dock-panel__live-stack :deep(.agora-inline__title) {
  display: inline-flex;
  align-items: center;
  min-height: 18px;
  padding: 0 6px;
  font-size: 12px;
  font-weight: 700;
  background: #4f4f4f;
}
.dock-panel__live-stack :deep(.agora-inline__status) {
  color: #bdbdbd;
  font-size: 12px;
}
.dock-panel__live-stack :deep(.agora-inline__player-wrap) {
  height: 360px;
  margin: 0;
  background: #000;
}
.dock-panel__live-stack :deep(.agora-inline__controls),
.dock-panel__live-stack :deep(.agora-inline__lenses) {
  margin: 0;
  padding: 4px 6px;
  background: #151515;
  border-top: 1px solid #262626;
}
.dock-panel__live-stack :deep(.ant-btn),
.dock-panel__live-stack :deep(.ant-select-selector),
.dock-panel__live-stack :deep(.ant-radio-button-wrapper) {
  border-radius: 1px;
}
.dock-panel__status-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 7px 9px;
  padding: 9px 10px 8px;
  background: #202020;
  border-bottom: 1px solid #363636;
}
.dock-panel__grid-item {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 3px;
  overflow: hidden;
  color: #fff;
  font-weight: 700;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dock-panel__grid-item--warn {
  color: #ff4d4f;
}
.dock-panel__grid-item--muted {
  color: #aaa;
}
.dock-panel__grid-item--home span:first-child {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  color: #d4b40e;
  border: 1px solid #d4b40e;
  border-radius: 50%;
  font-size: 10px;
  line-height: 12px;
}
.dock-panel__battery {
  position: relative;
  height: 12px;
  margin: 0 10px;
}
.tsa-live-window {
  position: absolute;
  left: calc(16px + var(--tsa-live-window-offset, 0px));
  top: calc(16px + var(--tsa-live-window-offset, 0px));
  z-index: 20;
  display: flex;
  flex-direction: column;
  width: 560px;
  height: 430px;
  min-width: 460px;
  min-height: 340px;
  color: #fff;
  background: #151515;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 4px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.45);
  overflow: hidden;

  &:deep(.agora-inline) {
    display: flex;
    flex-direction: column;
    height: 100%;
    margin: 0;
    box-sizing: border-box;
    background: transparent;
    border: 0;
  }

  &:deep(.agora-inline__player-wrap) {
    flex: 1;
    min-height: 180px;
    height: auto;
  }

  &:deep(.agora-inline__header),
  &:deep(.agora-inline__controls),
  &:deep(.agora-inline__lenses) {
    flex: 0 0 auto;
  }
}
.tsa-live-window__title {
  flex: 0 0 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  height: 40px;
  padding: 0 12px;
  color: #fff;
  background: #232323;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  user-select: none;
}
.tsa-live-window__heading {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
}
.tsa-live-window__sn {
  min-width: 0;
  max-width: 300px;
  color: #b7c3d0;
  font-weight: 400;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tsa-live-window__close {
  flex: 0 0 auto;
}
.osd-panel__close,
.tsa-live-window__close,
.liveview__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  color: #fff;
  font-size: 16px;
  line-height: 1;
  font-family: inherit;
  background: transparent;
  border: 0;
  border-radius: 2px;
  cursor: pointer;
  appearance: none;
}
.osd-panel__close:hover,
.tsa-live-window__close:hover,
.liveview__close:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.12);
}
.tsa-live-window__body {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
.tsa-live-window__resize {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 18px;
  height: 18px;
  cursor: nwse-resize;
}
.tsa-live-window__resize::before,
.tsa-live-window__resize::after {
  content: '';
  position: absolute;
  right: 4px;
  bottom: 4px;
  border-right: 1px solid rgba(255, 255, 255, 0.68);
  border-bottom: 1px solid rgba(255, 255, 255, 0.68);
}
.tsa-live-window__resize::before {
  width: 12px;
  height: 12px;
}
.tsa-live-window__resize::after {
  width: 7px;
  height: 7px;
}
.osd > div:not(.dock-control-panel) {
  margin-top: 5px;
  padding-left: 5px;
}

.circle {
  border-radius: 50%;
  width: 10px;
  height: 10px;
}

.battery-slide {
  .capacity-percent {
    background: #00ee8b;
  }
  .return-home {
    background: #ff9f0a;
  }
  .landing {
    background: #f5222d;
  }
  .white-point {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: white;
    bottom: -0.5px;
  }
  .battery {
    background: #141414;
    color: #00ee8b;
    margin-top: -10px;
    height: 20px;
    width: auto;
    border-left: 1px solid #00ee8b;
    padding: 0 5px;
  }
}
.battery-slide > div {
  position: absolute;
  min-height: 2px;
  border-radius: 2px;
}

.liveview {
  position: absolute;
  color: #fff;
  z-index: 1;
  left: 0;
  margin-left: 10px;
  top: 10px;
  text-align: center;
  width: 800px;
  height: 720px;
  background: #232323;
}
.liveview__close {
  position: absolute;
  right: 10px;
  top: 10px;
}
</style>
